{
  "$ - United States Dollar (USD)": "$ - United States Dollar (USD)",
  "%s ago": "{0} ago",
  "(Inferred type: {type})": "(Inferred type: {type})",
  "({n} currently executed)": "({n} currently executed)",
  "+{count} more": "+{count} more",
  "/ year": "/ year",
  "1 conversation matches": "1 conversation matches",
  "1 day": "1 day",
  "1 hour": "1 hour",
  "1 month": "1 month",
  "1 week": "1 week",
  "1 year": "1 year",
  "1-in-100-year annual loss": "1-in-100-year annual loss",
  "12 Months": "12 Months",
  "3 Months": "3 Months",
  "30 days": "30 days",
  "6 Months": "6 Months",
  "6 months": "6 months",
  "7d Change": "7d Change",
  "90 days": "90 days",
  "< Less than": "< Less than",
  "< {max} tokens": "< {max} tokens",
  "= Equal to": "= Equal to",
  "> Greater than": "> Greater than",
  "A GPAIM is classified as having systemic risk if it has high impact capabilities (e.g., trained with >10^25 FLOPs) or is designated by the Commission based on criteria in Article 51.": "A GPAIM is classified as having systemic risk if it has high impact capabilities (e.g., trained with >10^25 FLOPs) or is designated by the Commission based on criteria in Article 51.",
  "A draft version exists for this policy template.": "A draft version exists for this policy template.",
  "A draft version exists for this policy.": "A draft version exists for this policy.",
  "A failed verdict invalidates these Controls and notifies their owners.": "A failed verdict invalidates these Controls and notifies their owners.",
  "A person or entity established in the EU who has received written mandate from a provider outside the EU to act on their behalf.": "A person or entity established in the EU who has received written mandate from a provider outside the EU to act on their behalf.",
  "A published version exists for this policy template.": "A published version exists for this policy template.",
  "A published version exists for this policy.": "A published version exists for this policy.",
  "A two-parameter lognormal fixes skewness and tail behavior from those two anchors only.": "A two-parameter lognormal fixes skewness and tail behavior from those two anchors only.",
  "AI": "AI",
  "AI Agent": "AI Agent",
  "AI Agent Reasoning": "AI Agent Reasoning",
  "AI Agent analysis may take a few minutes to complete": "AI Agent analysis may take a few minutes to complete",
  "AI Agent analysis {bold} to complete, depending on the complexity of the risk context.": "AI Agent analysis {bold} to complete, depending on the complexity of the risk context.",
  "AI Agent suggestions reset successfully.": "AI Agent suggestions reset successfully.",
  "AI Application": "AI Application",
  "AI Applications": "AI Applications",
  "AI Apps": "AI Apps",
  "AI Assessment": "AI Assessment",
  "AI Assessment Coverage": "AI Assessment Coverage",
  "AI Assessment Progress": "AI Assessment Progress",
  "AI Cycle Stages": "AI Cycle Stages",
  "AI Generated": "AI Generated",
  "AI Governance Platform": "AI Governance Platform",
  "AI Lifecycle Stage": "AI Lifecycle Stage",
  "AI Lifecycle stages": "AI Lifecycle stages",
  "AI Model": "AI Model",
  "AI Pricing": "AI Pricing",
  "AI Quota": "AI Quota",
  "AI Readiness": "AI Readiness",
  "AI Registry": "AI Registry",
  "AI System": "AI System",
  "AI System & Details": "AI System & Details",
  "AI System Annual Economic Value": "AI System Annual Economic Value",
  "AI System Controls": "AI System Controls",
  "AI System Creator": "AI System Creator",
  "AI System Description": "AI System Description",
  "AI System Details": "AI System Details",
  "AI System Frameworks": "AI System Frameworks",
  "AI System Graph": "AI System Graph",
  "AI System Language": "AI System Language",
  "AI System Lifecycle": "AI System Lifecycle",
  "AI System Name": "AI System Name",
  "AI System Privileges": "AI System Privileges",
  "AI System Registration decision required": "AI System Registration decision required",
  "AI System Registration was rejected": "AI System Registration was rejected",
  "AI System Requirements": "AI System Requirements",
  "AI System Risk Limit": "AI System Risk Limit",
  "AI System Risk Limit Methods": "AI System Risk Limit Methods",
  "AI System Risk Limits": "AI System Risk Limits",
  "AI System Risk Value": "AI System Risk Value",
  "AI System Roles": "AI System Roles",
  "AI System exported successfully": "AI System exported successfully",
  "AI System is {status} for Framework updates.": "AI System is {status} for Framework updates.",
  "AI System risk limits updated successfully": "AI System risk limits updated successfully",
  "AI System settings updated successfully.": "AI System settings updated successfully.",
  "AI System was deleted": "AI System was deleted",
  "AI System {name} was approved": "AI System {name} was approved",
  "AI System {name} was created": "AI System {name} was created",
  "AI System {name} was rejected": "AI System {name} was rejected",
  "AI System {name} was submitted for review": "AI System {name} was submitted for review",
  "AI System {name} was updated": "AI System {name} was updated",
  "AI System · last chat {time}": "AI System · last chat {time}",
  "AI System(s)": "AI System(s)",
  "AI Systems": "AI Systems",
  "AI Systems Quota": "AI Systems Quota",
  "AI Systems Quota Count": "AI Systems Quota Count",
  "AI Systems list is empty.": "AI Systems list is empty.",
  "AI Systems with several values are grouped by their exact combination, so each is counted once.": "AI Systems with several values are grouped by their exact combination, so each is counted once.",
  "AI Systems · recent first": "AI Systems · recent first",
  "AI Usage": "AI Usage",
  "AI can make mistakes. Please double-check responses.": "AI can make mistakes. Please double-check responses.",
  "AI compliance": "AI compliance",
  "AI quota updated successfully": "AI quota updated successfully",
  "AI systems that interact with natural persons or generate synthetic content, requiring disclosure that users are interacting with AI or that content is AI-generated.": "AI systems that interact with natural persons or generate synthetic content, requiring disclosure that users are interacting with AI or that content is AI-generated.",
  "AI systems used in areas listed in Annex III of the EU AI Act, including: biometrics, critical infrastructure, education, employment, essential services, law enforcement, migration, and administration of justice.": "AI systems used in areas listed in Annex III of the EU AI Act, including: biometrics, critical infrastructure, education, employment, essential services, law enforcement, migration, and administration of justice.",
  "AI usage events": "AI usage events",
  "AI usage quota": "AI usage quota",
  "AI-powered risk quantification": "AI-powered risk quantification",
  "API Key is required": "API Key is required",
  "API Key*": "API Key*",
  "API Tokens": "API Tokens",
  "API URL (optional)": "API URL (optional)",
  "Abort Upload": "Abort Upload",
  "Accept": "Accept",
  "Acceptable zone": "Acceptable zone",
  "Access Key ID is required": "Access Key ID is required",
  "Access Key ID must be 20 uppercase alphanumeric characters": "Access Key ID must be 20 uppercase alphanumeric characters",
  "Access Key ID*": "Access Key ID*",
  "Access requested": "Access requested",
  "Account & Security": "Account & Security",
  "Account Identifier is required": "Account Identifier is required",
  "Account Identifier*": "Account Identifier*",
  "Account deactivated": "Account deactivated",
  "Acknowledge Policy": "Acknowledge Policy",
  "Acknowledged": "Acknowledged",
  "Acknowledged On": "Acknowledged On",
  "Acknowledgements": "Acknowledgements",
  "Action": "Action",
  "Actions": "Actions",
  "Activate User": "Activate User",
  "Activated": "Activated",
  "Active": "Active",
  "Active Users": "Active Users",
  "Active channels": "Active channels",
  "Active organizations": "Active organizations",
  "Active since": "Active since",
  "Active users": "Active users",
  "Active users and pending invitations count. Modulos staff are not counted.": "Active users and pending invitations count. Modulos staff are not counted.",
  "Activity": "Activity",
  "Activity feed": "Activity feed",
  "Activity, settings, plugins, adoption and cost in Claude Enterprise": "Activity, settings, plugins, adoption and cost in Claude Enterprise",
  "Add AI System Role": "Add AI System Role",
  "Add Category": "Add Category",
  "Add Connector": "Add Connector",
  "Add Evidence": "Add Evidence",
  "Add File(s)": "Add File(s)",
  "Add Framework": "Add Framework",
  "Add Framework(s)": "Add Framework(s)",
  "Add New": "Add New",
  "Add New Category": "Add New Category",
  "Add New Evidence": "Add New Evidence",
  "Add New Risk": "Add New Risk",
  "Add New Threat": "Add New Threat",
  "Add New Vendor": "Add New Vendor",
  "Add Placeholder": "Add Placeholder",
  "Add Risk": "Add Risk",
  "Add Risks": "Add Risks",
  "Add Source": "Add Source",
  "Add Threat": "Add Threat",
  "Add Threats": "Add Threats",
  "Add User": "Add User",
  "Add User to the AI System": "Add User to the AI System",
  "Add Vendor": "Add Vendor",
  "Add a Compliance Access Key to read this.": "Add a Compliance Access Key to read this.",
  "Add a note for the submitter.": "Add a note for the submitter.",
  "Add an Analytics API key to read this.": "Add an Analytics API key to read this.",
  "Add comment...": "Add comment...",
  "Add files from Google Drive": "Add files from Google Drive",
  "Add full EU AI Act details": "Add full EU AI Act details",
  "Add this app as an application user in the environment.": "Add this app as an application user in the environment.",
  "Added by": "Added by",
  "Additional filters are active": "Additional filters are active",
  "Address": "Address",
  "Address copied": "Address copied",
  "Address the reviewer feedback, then submit the AI System for review again.": "Address the reviewer feedback, then submit the AI System for review again.",
  "Adjust the period or return to a usage breakdown to choose another filter.": "Adjust the period or return to a usage breakdown to choose another filter.",
  "Admin": "Admin",
  "Admin API Key is required": "Admin API Key is required",
  "Admin API Key*": "Admin API Key*",
  "Adoption and cost": "Adoption and cost",
  "Advanced Search": "Advanced Search",
  "Advanced details": "Advanced details",
  "Advanced simulation settings": "Advanced simulation settings",
  "Affects which obligations apply to GPAIM providers.": "Affects which obligations apply to GPAIM providers.",
  "After sending this invitation the invited user will be listed as pending.": "After sending this invitation the invited user will be listed as pending.",
  "Agent": "Agent",
  "Agent ID is required": "Agent ID is required",
  "Agent ID*": "Agent ID*",
  "Agent Test": "Agent Test",
  "Agent Tests": "Agent Tests",
  "Agents: {count}": "Agents: {count}",
  "Aggregate sum of all values over time": "Aggregate sum of all values over time",
  "All": "All",
  "All AI Systems": "All AI Systems",
  "All AIAgent recommendations will be lost if you continue.": "All AI Agent recommendations will be lost if you continue.",
  "All Active": "All Active",
  "All Categories": "All Categories",
  "All Groups": "All Groups",
  "All Methods": "All Methods",
  "All Requirements": "All Requirements",
  "All Risk Categories": "All Risk Categories",
  "All Status": "All Status",
  "All Statuses": "All Statuses",
  "All Types": "All Types",
  "All available risks have already been added to this threat": "All available risks have already been added to this threat",
  "All available threats have already been added to this risk": "All available threats have already been added to this risk",
  "All context sizes": "All context sizes",
  "All controls": "All controls",
  "All controls executed, not fulfilled yet": "All controls executed, not fulfilled yet",
  "All deployments": "All deployments",
  "All frameworks are up to date.": "All frameworks are up to date.",
  "All scopes": "All scopes",
  "All sources": "All sources",
  "All sources (default)": "All sources (default)",
  "All {limit} of your seats are in use.": "All {limit} of your seats are in use.",
  "Allocation used": "Allocation used",
  "Allocation used (AI Systems)": "Allocation used (AI Systems)",
  "Allow Modulos to read messages and files": "Allow Modulos to read messages and files",
  "Allow Modulos to read messages and files?": "Allow Modulos to read messages and files?",
  "Already in use": "Already in use",
  "Always On": "Always On",
  "Always on": "Always on",
  "An AI model trained on broad data at scale, capable of competently performing a wide range of distinct tasks, and can be integrated into various downstream systems or applications.": "An AI model trained on broad data at scale, capable of competently performing a wide range of distinct tasks, and can be integrated into various downstream systems or applications.",
  "An Annex III use case the provider has assessed as not high-risk under the Article 6(3) derogation. The assessment must be documented before the system is placed on the market or put into service, the system registered under Article 49(2), and the documentation produced to national competent authorities on request.": "An Annex III use case the provider has assessed as not high-risk under the Article 6(3) derogation. The assessment must be documented before the system is placed on the market or put into service, the system registered under Article 49(2), and the documentation produced to national competent authorities on request.",
  "Analysis": "Analysis",
  "Analysis Breakdown": "Analysis Breakdown",
  "Analysis Status": "Analysis Status",
  "Analytics API Key": "Analytics API Key",
  "Analyzed": "Analyzed",
  "Annex III - Not High-Risk": "Annex III - Not High-Risk",
  "Annual Contract Value": "Annual Contract Value",
  "Annual loss": "Annual loss",
  "Annual loss exceeded in only {pct}% of years": "Annual loss exceeded in only {pct}% of years",
  "Annual probability": "Annual probability",
  "Answer": "Answer",
  "Answer saved as Temporary Evidence": "Answer saved as Temporary Evidence",
  "Answer the question to proceed with the questionnaire.": "Please answer the question to continue.",
  "Anthropic has not enabled organization settings for your parent organization yet. Contact your Anthropic representative.": "Anthropic has not enabled organization settings for your parent organization yet. Contact your Anthropic representative.",
  "Anthropic has not enabled the Analytics API for this organization. Contact your Anthropic representative.": "Anthropic has not enabled the Analytics API for this organization. Contact your Anthropic representative.",
  "Anthropic rejected the key. It may have been deleted or entered incorrectly. Create a new key and enter it again.": "Anthropic rejected the key. It may have been deleted or entered incorrectly. Create a new key and enter it again.",
  "App user found": "App user found",
  "App user missing": "App user missing",
  "Application Key*": "Application Key*",
  "Apply": "Apply",
  "Apply Changes": "Apply Changes",
  "Approaching limit": "Approaching limit",
  "Approaching threshold": "Approaching threshold",
  "Approve": "Approve",
  "Approve AI System": "Approve AI System",
  "Approved": "Approved",
  "Approved At": "Approved At",
  "Approved by {firstname} {lastname} at {date}": "Approved by {firstname} {lastname} at {date}",
  "Archive": "Archive",
  "Archive Policy": "Archive Policy",
  "Archive Policy Template": "Archive Policy Template",
  "Archive Risk": "Archive Risk",
  "Archive Risk Category": "Archive Risk Category",
  "Archive Threat": "Archive Threat",
  "Archived": "Archived",
  "Archived and out of scope controls will not be listed.": "Archived and out of scope controls will not be listed.",
  "Archived controls are skipped.": "Archived controls are skipped.",
  "Archiving this policy will affect the following associated controls. Executed controls will be set to Not Executed.": "Archiving this policy will affect the following associated controls. Executed controls will be set to Not Executed.",
  "Are you sure you want to archive this policy template? All drafts and published versions will be archived.": "Are you sure you want to archive this policy template? All drafts and published versions will be archived.",
  "Are you sure you want to archive this policy? All drafts and published versions will be archived.": "Are you sure you want to archive this policy? All drafts and published versions will be archived.",
  "Are you sure you want to archive this risk category? This action cannot be undone.": "Are you sure you want to archive this risk category? This action cannot be undone.",
  "Are you sure you want to archive this risk? This action cannot be undone.": "Are you sure you want to archive this risk? This action cannot be undone.",
  "Are you sure you want to archive this threat? This action cannot be undone.": "Are you sure you want to archive this threat? This action cannot be undone.",
  "Are you sure you want to delete the {connector} connector?": "Are you sure you want to delete the {connector} connector?",
  "Are you sure you want to leave?": "Are you sure you want to leave?",
  "Are you sure you want to move this policy version back to draft? A new approval will be required.": "Are you sure you want to move this policy version back to draft? A new approval will be required.",
  "Are you sure you want to publish this policy template version?": "Are you sure you want to publish this policy template version?",
  "Are you sure you want to publish this policy version?": "Are you sure you want to publish this policy version?",
  "Are you sure you want to switch tabs?": "Are you sure you want to switch tabs?",
  "Are you sure you want to unarchive this policy template? Status will be set to draft.": "Are you sure you want to unarchive this policy template? Status will be set to draft.",
  "Are you sure you want to unarchive this policy? Status will be set to draft.": "Are you sure you want to unarchive this policy? Status will be set to draft.",
  "Area is the Risk Value. Color is use of the Risk Limit.": "Area is the Risk Value. Color is use of the Risk Limit.",
  "Area is the Risk Value. Threat Vectors have no limit of their own: the header shows how much of the Risk Limit they use together.": "Area is the Risk Value. Threat Vectors have no limit of their own: the header shows how much of the Risk Limit they use together.",
  "Article 5 of the EU AI Act prohibits certain AI practices outright. A prohibited practice cannot be brought into compliance by controls, so this is settled before the risk classification.": "Article 5 of the EU AI Act prohibits certain AI practices outright. A prohibited practice cannot be brought into compliance by controls, so this is settled before the risk classification.",
  "Article 5 of the EU AI Act prohibits certain AI practices outright. A prohibited practice cannot be brought into compliance by controls. (Based on questionnaire question QH-14)": "Article 5 of the EU AI Act prohibits certain AI practices outright. A prohibited practice cannot be brought into compliance by controls. (Based on questionnaire question QH-14)",
  "As you have associated tests to this source you are not able to remove it.": "As you have associated tests to this source, you are not able to remove it.",
  "Ask Scout about": "Ask Scout about",
  "Ask about registering {name}": "Ask about registering {name}",
  "Ask about registering {name}: whether it needs registering, what to enter and what happens next.": "Ask about registering {name}: whether it needs registering, what to enter and what happens next.",
  "Ask about {name}": "Ask about {name}",
  "Ask about {name}: its controls, evidence, risks and tests.": "Ask about {name}: its controls, evidence, risks and tests.",
  "Ask across the AI Systems you have access to: where they stand and what needs attention next.": "Ask across the AI Systems you have access to: where they stand and what needs attention next.",
  "Ask across your AI Systems": "Ask across your AI Systems",
  "Ask an organization admin for access to this AI system's requirements and controls.": "Ask an organization admin for access to this AI system's requirements and controls.",
  "Ask for Approval": "Ask for Approval",
  "Assessed": "Assessed",
  "Assessed {when}": "Assessed {when}",
  "Assessed {when}, older than 90 days": "Assessed {when}, older than 90 days",
  "Assessment": "Assessment",
  "Assessment saved successfully": "Assessment saved successfully",
  "Asset": "Asset",
  "Asset Name": "Asset Name",
  "Asset Type": "Asset Type",
  "Asset content {name} was successfully updated": "Asset content {name} was successfully updated",
  "Asset {name} created successfully": "Asset {name} created successfully",
  "Asset {name} updated successfully": "Asset {name} updated successfully",
  "Asset {name} was successfully assigned to {firstname} {lastname}": "Asset {name} was successfully assigned to {firstname} {lastname}",
  "Asset {name} was updated": "Asset {name} was updated",
  "Assets": "Assets",
  "Assets list is empty": "Assets list is empty",
  "Assign To": "Assign To",
  "Assign the role to that application user.": "Assign the role to that application user.",
  "Assigned": "Assigned",
  "Assigned Controls": "Assigned Controls",
  "Assigned To": "Assigned To",
  "Assigned to me": "Assigned to me",
  "Assignee": "Assignee",
  "Assignments": "Assignments",
  "Associate Tag(s)": "Associate Tag(s)",
  "Associate to Control": "Associate to Control",
  "Associate to Control(s)": "Associate to Control(s)",
  "Associate to a Control": "Associate to a Control",
  "Associate to a Test": "Associate to a Test",
  "Associated Control(s)": "Associated Control(s)",
  "Associated Controls": "Associated Controls",
  "Associated Policies": "Associated Policies",
  "Associated Risks": "Associated Risks",
  "Associated Runtime Inspections": "Associated Runtime Inspections",
  "Associated Threats": "Associated Threats",
  "Association with Control {controlName} was removed": "Association with Control {controlName} was removed",
  "Associations": "Associations",
  "At least 10 characters": "At least 10 characters",
  "At least 2 characters": "At least 2 characters",
  "At least 5 characters required.": "At least 5 characters required.",
  "At least one owner is required": "At least one owner is required",
  "At least {amount}": "At least {amount}",
  "Attach a framework to this AI system to see its requirements, controls and tests here.": "Attach a framework to this AI system to see its requirements, controls and tests here.",
  "Audit Log": "Audit Log",
  "Auditor Findings": "Auditor Findings",
  "Authorised representative": "Authorised Representative",
  "Available": "Available",
  "Available once the document is processed": "Available once the document is processed",
  "Available once the documents are processed": "Available once the documents are processed",
  "Available to employees broadly": "Available to employees broadly",
  "Average count per year. Use 0.5 for \"once every two years\".": "Average count per year. Use 0.5 for \"once every two years\".",
  "Average loss in the worst {pct}% of years": "Average loss in the worst {pct}% of years",
  "Average score across {count} assessed controls": "Average score across {count} assessed controls",
  "Back": "Back",
  "Back to AI Systems": "Back to AI Systems",
  "Back to {name}": "Back to {name}",
  "Base Case": "Base Case",
  "Based on questionnaire questions QH-45, QH-46, QH-47 regarding downstream use.": "Based on questionnaire questions QH-45, QH-46, QH-47 regarding downstream use.",
  "Based on the answers provided, the following requirements and controls will be marked as  out of scope. You can always re-open them if they are needed.": "Based on your answers, the following requirements and controls will be marked as out of scope. You can re-open them if needed.",
  "Basic Information": "Basic Information",
  "Be precise about the domain: \"answers employee questions about HR policies\" and \"screens job applications\" are both HR chatbots, but they fall into very different risk categories. Describe your actual use, even if it differs from what the vendor markets the system for. Also note relevant limits, for example uses you have ruled out or blocked.": "Be precise about the domain: \"answers employee questions about HR policies\" and \"screens job applications\" are both HR chatbots, but they fall into very different risk categories. Describe your actual use, even if it differs from what the vendor markets the system for. Also note relevant limits, for example uses you have ruled out or blocked.",
  "Before Mitigation": "Before Mitigation",
  "Bernoulli · annual probability": "Bernoulli · annual probability",
  "Best Case": "Best Case",
  "Branch": "Branch",
  "Breakdown": "Breakdown",
  "Broken": "Broken",
  "Browse Bitbucket repositories": "Browse Bitbucket repositories",
  "Browse GitHub repositories": "Browse GitHub repositories",
  "By Framework": "By Framework",
  "By Group": "By Group",
  "By Lifecycle Stage": "By Lifecycle Stage",
  "By Risk Category": "By Risk Category",
  "By Tag": "By Tag",
  "By reactivating this user, you will restore their platform access.": "By reactivating this user, you will restore their platform access.",
  "CA$ - Canadian Dollar (CAD)": "CA$ - Canadian Dollar (CAD)",
  "CN¥ - Chinese Yuan (CNY)": "CN¥ - Chinese Yuan (CNY)",
  "CVaR at {alpha}%": "CVaR at {alpha}%",
  "Cache write": "Cache write",
  "Cached": "Cached",
  "Can create, edit, and manage policies and policy templates.": "Can create, edit, and manage policies and policy templates.",
  "Can manage risk assessments, frameworks, and risk-related configurations.": "Can manage risk assessments, frameworks, and risk-related configurations.",
  "Can review AI System registrations and approve or reject submissions.": "Can review AI System registrations and approve or reject submissions.",
  "Can this happen more than once per year?": "Can this happen more than once per year?",
  "Cancel": "Cancel",
  "Cancel Invitation": "Cancel Invitation",
  "Cancel Request": "Cancel Request",
  "Cancelled": "Cancelled",
  "Cancelled Invitation": "Cancelled Invitation",
  "Carries over to the registration.": "Carries over to the registration.",
  "Categories": "Categories",
  "Category": "Category",
  "Category Description": "Category Description",
  "Category Limit": "Category Limit",
  "Category Limits": "Category Limits",
  "Category Name": "Category Name",
  "Category Name*": "Category Name*",
  "Category Taxonomy": "Category Taxonomy",
  "Category is required": "Category is required",
  "Category name is required": "Category name is required",
  "Category {name} created successfully": "Category {name} created successfully",
  "Category {name} updated successfully": "Category {name} updated successfully",
  "Category*": "Category*",
  "Category:": "Category:",
  "Chance this event occurs at least once this year.": "Chance this event occurs at least once this year.",
  "Change Control status to \"Not Executed\"": "Change Control status to \"Not Executed\"",
  "Change Log": "Change Log",
  "Change Log Description": "Change Log Description",
  "Change Logs": "Change Logs",
  "Change Status": "Change Status",
  "Changed Frameworks": "Changed Frameworks",
  "Changes saved.": "Changes saved.",
  "Changing the method updates AI System-level guidance only. Category limits remain unchanged.": "Changing the method updates AI System-level guidance only. Category limits remain unchanged.",
  "Changing these settings may affect controls and requirements, review all the “out of scope” controls or re-take the Questionnaire.": "Changing these settings may impact the controls and requirements. Please review all out-of-scope items or retake the questionnaire.",
  "Channel Settings": "Channel Settings",
  "Check": "Check",
  "Check a measured metric against a threshold.": "Check a measured metric against a threshold.",
  "Check again": "Check again",
  "Check all the change logs": "Check all the change logs",
  "Check connection": "Check connection",
  "Check environments": "Check environments",
  "Check the rest": "Check the rest",
  "Checked {date}": "Checked {date}",
  "Checking connection": "Checking connection",
  "Choose a file": "Choose a file",
  "Choose how AI System limits are suggested. This selection does not change category risk limits.": "Choose how AI System limits are suggested. This selection does not change category risk limits.",
  "Choose which frameworks to assess. The agent reads the attached evidence for every control and scores its readiness.": "Choose which frameworks to assess. The agent reads the attached evidence for every control and scores its readiness.",
  "Choose which notifications you want to receive and how they are delivered.": "Choose which notifications you want to receive and how they are delivered.",
  "City": "City",
  "Clean Filters": "Clean Filters",
  "Clear All": "Clear All",
  "Clear Search": "Clear Search",
  "Clear Selection": "Clear Selection",
  "Clear scope filters to show threat vectors.": "Clear scope filters to show threat vectors.",
  "Clear search": "Clear search",
  "Clear the Dataverse URL to connect the whole tenant.": "Clear the Dataverse URL to connect the whole tenant.",
  "Client ID": "Client ID",
  "Client ID is required": "Client ID is required",
  "Client ID*": "Client ID*",
  "Client Secret is required": "Client Secret is required",
  "Client Secret*": "Client Secret*",
  "Clock: value older than 90 days": "Clock: value older than 90 days",
  "Close": "Close",
  "Close menu": "Close menu",
  "Code": "Code",
  "Collaboration": "Collaboration",
  "Collapse": "Collapse",
  "Collapse menu": "Collapse menu",
  "Colors": "Colors",
  "Columns": "Columns",
  "Coming Soon": "Coming Soon",
  "Comma-separated subscription IDs (leave empty for all)": "Comma-separated subscription IDs (leave empty for all)",
  "Comment": "Comment",
  "Commented": "Commented",
  "Comments & Logs": "Comments & Logs",
  "Comments and Logs": "Comments and Logs",
  "Compare frameworks": "Compare frameworks",
  "Completed": "Completed",
  "Compliance Access Key": "Compliance Access Key",
  "Condition": "Condition",
  "Configuration": "Configuration",
  "Configuration updated successfully": "Configuration updated successfully",
  "Configure Parameters": "Configure Parameters",
  "Configured": "Configured",
  "Confirm": "Confirm",
  "Confirm Changes": "Confirm Changes",
  "Confirm Scoping": "Confirm Scoping",
  "Confirm file selection for Evidence Creation. You can also associate controls or run the AI\n        Agent before processing. It may take time – we'll notify you when ready.": "Confirm file selection for Evidence Creation. You can also associate controls or run the AI Agent before processing. It may take time – we'll notify you when ready.",
  "Confirming with the scoping, control MCF-150 will be populated with Summary of Scoping as Evidence. Questionnaire can be repeated infinite amount of times.": "Once confirmed, control MCF-150 will include the Summary of Scoping as evidence. The questionnaire can be repeated unlimited times.",
  "Connect Sources": "Connect Sources",
  "Connect external sources to use with Scout": "Connect external sources to use with Scout",
  "Connect observability or infrastructure sources for this system. You can also do this later in Settings.": "Connect observability or infrastructure sources for this system. You can also do this later in Settings.",
  "Connected": "Connected",
  "Connection": "Connection",
  "Connection Instructions": "Connection Instructions",
  "Connection lost.": "Connection lost.",
  "Connection successful!": "Connection successful!",
  "Connector": "Connector",
  "Connector created successfully": "Connector created successfully",
  "Connector deleted successfully": "Connector deleted successfully",
  "Connector expired": "Connector expired",
  "Connector list is empty.": "Connector list is empty.",
  "Connector updated successfully": "Connector updated successfully",
  "Connectors": "Connectors",
  "Connectors are personal. Each user links their own Google Drive, GitHub, Atlassian or Bitbucket account in their profile settings, and only they can use it: Scout reads the files and repositories they bring into their own conversations. Nothing is shared with colleagues, and connectors never feed tests.": "Connectors are personal. Each user links their own Google Drive, GitHub, Atlassian or Bitbucket account in their profile settings, and only they can use it: Scout reads the files and repositories they bring into their own conversations. Nothing is shared with colleagues, and connectors never feed tests.",
  "Consider your record keeping obligations before proceeding with deletion.": "Consider your record keeping obligations before proceeding with deletion.",
  "Contact Sales": "Contact Sales",
  "Contact sales to upgrade your plan.": "Contact sales to upgrade your plan.",
  "Contact your Org Admin to re-enable email delivery.": "Contact your Org Admin to re-enable email delivery.",
  "Contact your administrator to enable them.": "Contact your administrator to enable them.",
  "Content": "Content",
  "Content Preview": "Content Preview",
  "Content generated by AI can present mistakes, always check and make the necessary adjustments.": "Content generated by AI can present mistakes, always check and make the necessary adjustments.",
  "Context": "Context",
  "Context tier": "Context tier",
  "Continue": "Continue",
  "Continue Later": "Continue Later",
  "Contractor": "Contractor",
  "Contribution": "Contribution",
  "Control": "Control",
  "Control Assessment": "Control Assessment",
  "Control Assessments": "Control Assessments",
  "Control Readiness": "Control Readiness",
  "Control Status": "Control Status",
  "Control components updated successfully": "Control components updated successfully",
  "Control owner was updated": "Control owner was updated",
  "Control status updated successfully": "Control status updated successfully",
  "Control {control} successfully associated with Test {test}": "Control {control} successfully associated with Test {test}",
  "Control {name} was updated": "Control {name} was updated",
  "Control(s)": "Control(s)",
  "Controls": "Controls",
  "Controls assessed": "Controls assessed",
  "Controls list is empty": "Controls list is empty",
  "Controls moving IN scope": "Controls moving IN scope",
  "Controls moving OUT of scope": "Controls moving OUT of scope",
  "Controls were updated": "Controls were updated",
  "Conversation history": "Conversation history",
  "Conversation name": "Conversation name",
  "Copied": "Copied",
  "Copied to clipboard": "Copied to clipboard",
  "Copy": "Copy",
  "Copy Link": "Copy Link",
  "Copy address": "Copy address",
  "Copy answer": "Copy answer",
  "Copy code to programmatically upload files": "Copy code to programmatically upload files",
  "Copy log information": "Copy log information",
  "Copy prompt": "Copy prompt",
  "Copy source": "Copy source",
  "Copy the sales email address": "Copy the sales email address",
  "Cost": "Cost",
  "Could not copy value": "Could not copy value",
  "Could not load associated controls. Archiving may affect linked controls — proceed with caution.": "Could not load associated controls. Archiving may affect linked controls — proceed with caution.",
  "Could not open Google Drive. Please try again.": "Could not open Google Drive. Please try again.",
  "Could not reach Scout.": "Could not reach Scout.",
  "Could not refresh the document processing status": "Could not refresh the document processing status",
  "Could not refresh the upload status": "Could not refresh the upload status",
  "Country": "Country",
  "Covers controls": "Covers controls",
  "Create": "Create",
  "Create AI System": "Create AI System",
  "Create AI Systems? | Create {count} AI System? | Create {count} AI Systems?": "Create AI Systems? | Create {count} AI System? | Create {count} AI Systems?",
  "Create Control AI Assessment Job": "Create Control AI Assessment Job",
  "Create From Template": "Create From Template",
  "Create Job": "Create Job",
  "Create New": "Create New",
  "Create New AI System": "Create New AI System",
  "Create New Asset": "Create New Asset",
  "Create New Policy": "Create New Policy",
  "Create New Policy Template": "Create New Policy Template",
  "Create New Test": "Create New Test",
  "Create Policy": "Create Policy",
  "Create Policy from Template": "Create Policy from Template",
  "Create Risk Quantification Job": "Create Risk Quantification Job",
  "Create Test": "Create Test",
  "Create Test Job": "Create Test Job",
  "Create Token": "Create Token",
  "Create a Compliance Access Key": "Create a Compliance Access Key",
  "Create an Analytics API key (optional)": "Create an Analytics API key (optional)",
  "Create and Run": "Create and Run",
  "Create or import a security role with Organization-level Read on Agent (bot) and Agent component (botcomponent), and nothing else.": "Create or import a security role with Organization-level Read on Agent (bot) and Agent component (botcomponent), and nothing else.",
  "Create this AI System?": "Create this AI System?",
  "Create your first policy template to get started.": "Create your first policy template to get started.",
  "Create your first policy to get started.": "Create your first policy to get started.",
  "Created": "Created",
  "Created At": "Created At",
  "Created By": "Created By",
  "Created by": "Created by",
  "Created {count} AI Systems as Drafts.": "Created {count} AI Systems as Drafts.",
  "Created {name} as a Draft.": "Created {name} as a Draft.",
  "Credible high": "Credible high",
  "Credible low": "Credible low",
  "Currency": "Currency",
  "Current Analysis": "Current Analysis",
  "Current Risk": "Current Risk",
  "Current State": "Current State",
  "Current Value": "Current Value",
  "Current Version": "Current Version",
  "Current billing month": "Current billing month",
  "Current month": "Current month",
  "Current month usage": "Current month usage",
  "Current monthly spend": "Current monthly spend",
  "Current usage for {organization}.": "Current usage for {organization}.",
  "Currently-effective AI model prices from the platform pricing catalogue, per 1M tokens. These are the rates used to cost every AI usage event.": "Currently-effective AI model prices from the platform pricing catalogue, per 1M tokens. These are the rates used to cost every AI usage event.",
  "Custom T&C": "Custom T&C",
  "Custom Terms & Conditions": "Custom Terms & Conditions",
  "Custom range": "Custom range",
  "Customer-facing": "Customer-facing",
  "Customization": "Customization",
  "Daily": "Daily",
  "Danger Zone": "Danger Zone",
  "Dashboard": "Dashboard",
  "Data Not Found": "Data Not Found",
  "Data Source": "Data Source",
  "Database is required": "Database is required",
  "Database*": "Database*",
  "Dataset Card": "Dataset Card",
  "Dataverse environment URL": "Dataverse environment URL",
  "Date": "Date",
  "Date and Time": "Date and Time",
  "Deactivate User": "Deactivate User",
  "Deactivating a user's platform access will invalidate any of their API tokens (if existent).": "Deactivating a user's platform access will invalidate any of their API tokens (if existent).",
  "Default": "Default",
  "Default Organization Language": "Default Organization Language",
  "Default branch will be used if not specified": "Default branch will be used if not specified",
  "Delete": "Delete",
  "Delete AI System": "Delete AI System",
  "Delete All": "Delete All",
  "Delete Connector": "Delete Connector",
  "Delete Draft": "Delete Draft",
  "Delete File": "Delete File",
  "Delete Risk": "Delete Risk",
  "Delete Threat": "Delete Threat",
  "Delete file": "Delete file",
  "Delete file(s)": "Delete file(s)",
  "Delete this AI System": "Delete this AI System",
  "Delete this conversation?": "Delete this conversation?",
  "Delete {name}?": "Delete {name}?",
  "Deleted": "Deleted",
  "Deleting this evidence will affect the following associated controls, which will lose their connection to this evidence.": "Deleting this evidence will affect the following associated controls, which will lose their connection to this evidence.",
  "Deleting this threat will remove it from the risk. This action cannot be undone. Do you want to continue?": "Deleting this threat will remove it from the risk. This action cannot be undone. Do you want to continue?",
  "Deliver notifications to Microsoft Teams channels.": "Deliver notifications to Microsoft Teams channels.",
  "Delivers notifications to each user's registered email address.": "Delivers notifications to each user's registered email address.",
  "Deloitte Partner": "Deloitte Partner",
  "Depending on the answers some questions can be skipped.": "Some questions may be skipped depending on your answers.",
  "Deployer": "Deployer",
  "Deployment": "Deployment",
  "Descoped Controls": "Descoped Controls",
  "Descoped Requirements": "Descoped Requirements",
  "Describe what this Source represents in the wider context of your AI System, e.g. “this is the main code repository“": "Describe what this Source represents in the wider context of your AI System, e.g. “this is the main code repository“",
  "Describe what this system is and how it works, in your own words. Useful details: the type of technology (a chatbot built on a large language model, a scoring model, a forecasting tool), what data goes in, what outputs it produces, who in your organization works with those outputs, and whether it runs standalone or inside another product.": "Describe what this system is and how it works, in your own words. Useful details: the type of technology (a chatbot built on a large language model, a scoring model, a forecasting tool), what data goes in, what outputs it produces, who in your organization works with those outputs, and whether it runs standalone or inside another product.",
  "Describe what to check in plain language. The agent gathers evidence and returns a verdict.": "Describe what to check in plain language. The agent gathers evidence and returns a verdict.",
  "Describe what your organization uses this system for, or plans to use it for. Three things matter most: the task it performs and in which business process, the people affected by its outputs (employees, job applicants, customers, patients, the public), and whether it supports a human decision or acts on its own.": "Describe what your organization uses this system for, or plans to use it for. Three things matter most: the task it performs and in which business process, the people affected by its outputs (employees, job applicants, customers, patients, the public), and whether it supports a human decision or acts on its own.",
  "Describing image": "Describing image",
  "Description": "Description",
  "Description is required": "Description is required",
  "Description*": "Description*",
  "Description:": "Description:",
  "Details": "Details",
  "Determines whether EU AI Act applies as AI System or General Purpose AI Model regulations.": "Determines whether EU AI Act applies as AI System or General Purpose AI Model regulations.",
  "Develops an AI system or GPAIM and places it on the market or puts it into service under own name or trademark, whether for payment or free of charge.": "Develops an AI system or GPAIM and places it on the market or puts it into service under own name or trademark, whether for payment or free of charge.",
  "Diagnostics": "Diagnostics",
  "Diagram": "Diagram",
  "Different roles have different obligations under the EU AI Act.": "Different roles have different obligations under the EU AI Act.",
  "Direct input of risk values": "Direct input of risk values",
  "Disable 2FA": "Disable 2FA",
  "Disabled": "Disabled",
  "Disabled in your organization": "Disabled in your organization",
  "Discard": "Discard",
  "Discover environments": "Discover environments",
  "Dismiss": "Dismiss",
  "Distribute AI System limits based on projected economic value or ROI for each initiative.": "Distribute AI System limits based on projected economic value or ROI for each initiative.",
  "Distribution": "Distribution",
  "Distribution percentiles": "Distribution percentiles",
  "Distributor": "Distributor",
  "Document list is empty": "Document list is empty",
  "Document successfully uploaded": "Document successfully uploaded",
  "Documents": "Documents",
  "Does the EU AI Act apply to this AI System?": "Does the EU AI Act apply to this AI System?",
  "Does this tool need to be registered?": "Does this tool need to be registered?",
  "Done": "Done",
  "Download": "Download",
  "Download File": "Download File",
  "Download PNG": "Download PNG",
  "Download the full list ({count})": "Download the full list ({count})",
  "Draft": "Draft",
  "Draft · last chat {time}": "Draft · last chat {time}",
  "Draft · not submitted yet": "Draft · not submitted yet",
  "Drafts": "Drafts",
  "Drop your files here or click to browse": "Drop your files here or click to browse",
  "Duplicate of": "Duplicate of",
  "Duplicated": "Duplicated",
  "Duration": "Duration",
  "Duration*": "Duration*",
  "E.g. Production Metric Server": "E.g. Production Metric Server",
  "E.g. https://api.example.com": "E.g. https://api.example.com",
  "E.g. https://github.com/owner/repo": "E.g. https://github.com/owner/repo",
  "EMA": "EMA",
  "EU AI Act": "EU AI Act",
  "EU AI Act Assessment": "EU AI Act Assessment",
  "EU AI Act Questionnaire": "EU AI Act Questionnaire",
  "EU AI Act Tags": "EU AI Act Tags",
  "EU Artificial Intelligence Act": "EU Artificial Intelligence Act",
  "EU deployment or affects EU subjects": "EU deployment or affects EU subjects",
  "Each method shown as a stacked area": "Each method shown as a stacked area",
  "Earlier": "Earlier",
  "Economic Value": "Economic Value",
  "Economic Value-Based Allocation": "Economic Value-Based Allocation",
  "Edit": "Edit",
  "Edit AI System Settings": "Edit AI System Settings",
  "Edit Agent Test": "Edit Agent Test",
  "Edit Category": "Edit Category",
  "Edit Control AI Assessment Job": "Edit Control AI Assessment Job",
  "Edit Evidence": "Edit Evidence",
  "Edit Info": "Edit Info",
  "Edit Job": "Edit Job",
  "Edit Reviewer(s)": "Edit Reviewer(s)",
  "Edit Risk": "Edit Risk",
  "Edit Risk Quantification Job": "Edit Risk Quantification Job",
  "Edit Risks": "Edit Risks",
  "Edit Source": "Edit Source",
  "Edit Test": "Edit Test",
  "Edit Test Job": "Edit Test Job",
  "Edit Threat": "Edit Threat",
  "Edit Threats": "Edit Threats",
  "Edit User": "Edit User",
  "Edit User Access": "Edit User Access",
  "Edit Vendor": "Edit Vendor",
  "Edit in Settings": "Edit in Settings",
  "Editor": "Editor",
  "Effective from": "Effective from",
  "Email": "Email",
  "Email Domain": "Email Domain",
  "Email Notifications": "Email Notifications",
  "Email doesn't match": "Email doesn't match",
  "Email not verified": "Email not verified",
  "Email notifications are disabled for your organization.": "Email notifications are disabled for your organization.",
  "Embedded in product": "Embedded in product",
  "Employee-facing": "Employee-facing",
  "Enable": "Enable",
  "Enable All": "Enable All",
  "Enable or disable delivery channels for your entire organization. Changes take effect immediately after saving.": "Enable or disable delivery channels for your entire organization. Changes take effect immediately after saving.",
  "Enable quota monitoring": "Enable quota monitoring",
  "Enable the Compliance API": "Enable the Compliance API",
  "Enabled": "Enabled",
  "Engine": "Engine",
  "Enter IAM secret access key": "Enter IAM secret access key",
  "Enter Service Principal client secret": "Enter Service Principal client secret",
  "Enter a 6-digit code": "Enter a 6-digit code",
  "Enter a Compliance Access Key, an Analytics API key, or both": "Enter a Compliance Access Key, an Analytics API key, or both",
  "Enter a positive number of events per year.": "Enter a positive number of events per year.",
  "Enter a threshold to see exceedance probability.": "Enter a threshold to see exceedance probability.",
  "Enter a valid Dataverse environment URL without a trailing slash or path": "Enter a valid Dataverse environment URL without a trailing slash or path",
  "Enter a value between 0 and 100.": "Enter a value between 0 and 100.",
  "Enter an https URL with host and port only, for example https://api.anthropic.com": "Enter an https URL with host and port only, for example https://api.anthropic.com",
  "Enter annual economic value": "Enter annual economic value",
  "Enter both values to preview the loss curve.": "Enter both values to preview the loss curve.",
  "Enter category name": "Enter category name",
  "Enter description (required)": "Enter description (required)",
  "Enter every key this source should keep: an empty key field removes the stored key.": "Enter every key this source should keep: an empty key field removes the stored key.",
  "Enter new name...": "Enter new name...",
  "Enter one key or both. Modulos checks what each key can read and shows the result on the source": "Enter one key or both. Modulos checks what each key can read and shows the result on the source",
  "Enter policy name": "Enter policy name",
  "Enter policy template description": "Enter policy template description",
  "Enter policy template description (optional)": "Enter policy template description (optional)",
  "Enter policy template name": "Enter policy template name",
  "Enter replacement value": "Enter replacement value",
  "Enter risk name": "Enter risk name",
  "Enter the highest plausible loss (greater than 0).": "Enter the highest plausible loss (greater than 0).",
  "Enter the keys": "Enter the keys",
  "Enter the lowest plausible loss (greater than 0).": "Enter the lowest plausible loss (greater than 0).",
  "Enter threat name": "Enter threat name",
  "Enter your API key": "Enter your API key",
  "Enter your Analytics API key": "Enter your Analytics API key",
  "Enter your Langfuse public key": "Enter your Langfuse public key",
  "Enter your Langfuse secret key": "Enter your Langfuse secret key",
  "Enter your Programmatic Access Token": "Enter your Programmatic Access Token",
  "Enter your Vijil Console Agent ID": "Enter your Vijil Console Agent ID",
  "Enter your Vijil client secret": "Enter your Vijil client secret",
  "Enter your application key": "Enter your application key",
  "Entered Value": "Entered Value",
  "Environments": "Environments",
  "Equal Distribution (default)": "Equal Distribution (default)",
  "Error": "Error",
  "Estimate the annual economic value this system delivers or is expected to deliver: revenue it enables, costs it saves, or losses it avoids, per year. Use your organization's own projections; a rough order-of-magnitude estimate is fine at onboarding and can be refined later.": "Estimate the annual economic value this system delivers or is expected to deliver: revenue it enables, costs it saves, or losses it avoids, per year. Use your organization's own projections; a rough order-of-magnitude estimate is fine at onboarding and can be refined later.",
  "Estimate the loss size and how often this happens. We run thousands of simulated years using your inputs to produce a realistic annual-loss distribution.": "Estimate the loss size and how often this happens. We run thousands of simulated years using your inputs to produce a realistic annual-loss distribution.",
  "Estimated cost": "Estimated cost",
  "Estimation Justification": "Estimation Justification",
  "Estimation Source": "Estimation Source",
  "Every AI System you can see, and {organization}": "Every AI System you can see, and {organization}",
  "Every created system counts. Drafts do not.": "Every created system counts. Drafts do not.",
  "Every day at {time}, from {date}": "Every day at {time}, from {date}",
  "Every quarter at {time}, from {date}": "Every quarter at {time}, from {date}",
  "Every {weekday} at {time}, from {date}": "Every {weekday} at {time}, from {date}",
  "Everyone with access to this AI System can then have Scout and Agent Tests read messages, files and titles from your Claude Enterprise organization.": "Everyone with access to this AI System can then have Scout and Agent Tests read messages, files and titles from your Claude Enterprise organization.",
  "Evidence": "Evidence",
  "Evidence Creation": "Evidence Creation",
  "Evidence Description": "Evidence Description",
  "Evidence ID copied": "Evidence ID copied",
  "Evidence Library": "Evidence Library",
  "Evidence Manager": "Evidence Manager",
  "Evidence Name": "Evidence Name",
  "Evidence Name*": "Evidence Name*",
  "Evidence created successfully.": "Evidence created successfully.",
  "Evidence creation cancelled successfully": "Evidence creation cancelled successfully",
  "Evidence creation cancelled successfully.": "Evidence creation cancelled successfully.",
  "Evidence deleted successfully": "Evidence deleted successfully",
  "Evidence is frozen because the following items are in review, completed or executed:": "Evidence is frozen because the following items are in review, completed or executed:",
  "Evidence list is empty": "Evidence list is empty",
  "Evidence removed from component": "Evidence removed from component",
  "Evidence {name} added to component successfully": "Evidence {name} added to component successfully",
  "Evidence {name} updated successfully": "Evidence {name} updated successfully",
  "Exceedance": "Exceedance",
  "Exceeds the AI System risk limit ({amount})": "Exceeds the AI System risk limit ({amount})",
  "Exceeds threshold": "Exceeds threshold",
  "Executed": "Executed",
  "Execution Log": "Execution Log",
  "Execution log copied": "Execution log copied",
  "Executive Summary": "Executive Summary",
  "Expand": "Expand",
  "Expand menu": "Expand menu",
  "Expected annual loss": "Expected annual loss",
  "Expected events per year": "Expected events per year",
  "Expected {rate} events per year": "Expected {rate} events per year",
  "Expired": "Expired",
  "Expired Invitation": "Expired Invitation",
  "Expires At": "Expires At",
  "Explain and document your reasoning for your chosen EU AI Act Risk Classification in this control": "Explain and document your reasoning for your chosen EU AI Act Risk Classification in this control",
  "Explain why this AI System cannot proceed. The submitter sees this message.": "Explain why this AI System cannot proceed. The submitter sees this message.",
  "Exponential Moving Average — reacts faster to recent changes": "Exponential Moving Average — reacts faster to recent changes",
  "Export": "Export",
  "Extracting text": "Extracting text",
  "Failed": "Failed",
  "Failed Tests": "Failed Tests",
  "Failed to add evidence to component: ": "Failed to add evidence to component: ",
  "Failed to complete authorization": "Failed to complete authorization",
  "Failed to create draft version": "Failed to create draft version",
  "Failed to load AI pricing.": "Failed to load AI pricing.",
  "Failed to load AI quota.": "Failed to load AI quota.",
  "Failed to load AI usage.": "Failed to load AI usage.",
  "Failed to load PDF.": "Failed to load PDF.",
  "Failed to load SSO status.": "Failed to load SSO status.",
  "Failed to load connectors": "Failed to load connectors",
  "Failed to load file.": "Failed to load file.",
  "Failed to load image.": "Failed to load image.",
  "Failed to load scope preview": "Failed to load scope preview",
  "Failed to upload file: {name}": "Failed to upload file: {name}",
  "Feature": "Feature",
  "Features": "Features",
  "Fermi Quantification powered by Scout": "Fermi Quantification powered by Scout",
  "File": "File",
  "File \"{name}\" could not be uploaded due to an unknown error.": "File \"{name}\" could not be uploaded due to an unknown error.",
  "File \"{name}\" does not meet the filter criteria.": "File \"{name}\" does not meet the filter criteria.",
  "File \"{name}\" exceeds the maximum file size of {size} MB.": "File \"{name}\" exceeds the maximum file size of {size} MB.",
  "File \"{name}\" has an unsupported file type.": "File \"{name}\" has an unsupported file type.",
  "File \"{name}\" is a duplicate.": "File \"{name}\" is a duplicate.",
  "File Name": "File Name",
  "File exceeds 100 MB limit": "File exceeds 100 MB limit",
  "File must be a PDF": "File must be a PDF",
  "Files limit exceeded.": "Files limit exceeded.",
  "Files uploaded info": "{filesAmount} file(s) uploaded - {uploadedSize} / {uploadProgress}",
  "Fill in the basic information to create a new policy from": "Fill in the basic information to create a new policy from",
  "Filter": "Filter",
  "Filter by scope": "Filter by scope",
  "Financial Risk:": "Financial Risk:",
  "First framework": "First framework",
  "Fit view": "Fit view",
  "Fitted lognormal · 5th / 95th percentile": "Fitted lognormal · 5th / 95th percentile",
  "For anything accessible from outside your organization, ask what actually limits its reach: if there are no geographic guardrails, technical or contractual, the honest answer is Global. Select EU whenever outputs are used in the EU or affect people there, even if your organization has no EU entity; that alone can bring the system into scope of EU rules.": "For anything accessible from outside your organization, ask what actually limits its reach: if there are no geographic guardrails, technical or contractual, the honest answer is Global. Select EU whenever outputs are used in the EU or affect people there, even if your organization has no EU entity; that alone can bring the system into scope of EU rules.",
  "For example: approved by our data protection officer on 12 October 2026, ref. DPO-42.": "For example: approved by our data protection officer on 12 October 2026, ref. DPO-42.",
  "For your security, please sign in again before disabling two-factor authentication.": "For your security, please sign in again before disabling two-factor authentication.",
  "Force Update": "Force Update",
  "Force update for status change was successful": "Force update for status change was successful",
  "Forces a status update without a review process. You can include a comment to document your decision.": "Forces a status update without a review process. You can include a comment to document your decision.",
  "Found {count} findings": "Found {count} findings",
  "Fr. - Swiss Franc (CHF)": "Fr. - Swiss Franc (CHF)",
  "Framework": "Framework",
  "Framework Name": "Framework Name",
  "Framework {code} {status} for {organizationName}": "Framework {code} {status} for {organizationName}",
  "Framework {name} {status} successfully.": "Framework {name} {status} successfully.",
  "Framework(s) successfully added to the AI System": "Framework(s) successfully added to the AI System",
  "Frameworks": "Frameworks",
  "Frameworks list is empty": "Frameworks list is empty",
  "Frameworks updated successfully to the latest version.": "Frameworks updated successfully to the latest version.",
  "Freemium Services Terms and Conditions": "Freemium Services Terms and Conditions",
  "Freeze Updates": "Freeze Updates",
  "Freezing the AI System will prevent anyone from updating the frameworks. Editing the AI System will still be possible.": "Freezing the AI System will prevent anyone from updating the frameworks. Editing the AI System will still be possible.",
  "Frequency": "Frequency",
  "Frequency Multiplier": "Frequency Multiplier",
  "Frequency*": "Frequency*",
  "Fulfilled": "Fulfilled",
  "Full administrative access to organization settings, users, and billing.": "Full administrative access to organization settings, users, and billing.",
  "Fully quantified": "Fully quantified",
  "Gaps": "Gaps",
  "General": "General",
  "General Card": "General Card",
  "General Purpose AI Model": "General Purpose AI Model",
  "General Purpose AI Models with systemic risk have additional obligations.": "General Purpose AI Models with systemic risk have additional obligations.",
  "General Settings": "General Settings",
  "Generating summary": "Generating summary",
  "Geographic Scope": "Geographic Scope",
  "Give it a name to start. It is saved as a draft you complete in the next steps.": "Give it a name to start. It is saved as a draft you complete in the next steps.",
  "Give the system a name your colleagues would recognize, ideally the product name plus how you use it, for example \"Claude for Customer Support\" rather than just \"Claude\".": "Give the system a name your colleagues would recognize, ideally the product name plus how you use it, for example \"Claude for Customer Support\" rather than just \"Claude\".",
  "Give the test a descriptive name": "Give the test a descriptive name",
  "Global": "Global",
  "Go to AI Registry": "Go to AI Registry",
  "Go to Policy Center": "Go to Policy Center",
  "Go to Settings": "Go to Settings",
  "Go to parent folder": "Go to parent folder",
  "Go to the Dashboard": "Go to the Dashboard",
  "Go-Live Date": "Go-Live Date",
  "Good afternoon": "Good afternoon",
  "Good afternoon, {firstName}": "Good afternoon, {firstName}",
  "Good evening": "Good evening",
  "Good evening, {firstName}": "Good evening, {firstName}",
  "Good morning": "Good morning",
  "Good morning, {firstName}": "Good morning, {firstName}",
  "Google Chat": "Google Chat",
  "Google Drive is not configured": "Google Drive is not configured",
  "Governance and Compliance": "Governance and Compliance",
  "Graph": "Graph",
  "Graph. Arrow keys to pan, plus and minus to zoom, Home to fit. Use search to select a node.": "Graph. Arrow keys to pan, plus and minus to zoom, Home to fit. Use search to select a node.",
  "Greater than or equal to": "Greater than or equal to",
  "Group": "Group",
  "Group by": "Group by",
  "Guidance": "Guidance",
  "Harness": "Harness",
  "Healthy": "Healthy",
  "Heavy tail (σ_log > {threshold}). Annual losses will be dominated by rare extreme events; the lognormal tail assumption matters.": "Heavy tail (σ_log > {threshold}). Annual losses will be dominated by rare extreme events; the lognormal tail assumption matters.",
  "Hello": "Hello",
  "Hello, ": "Hello, ",
  "Hello, {firstName}": "Hello, {firstName}",
  "Hi Modulos team,": "Hi Modulos team,",
  "Hide conversations": "Hide conversations",
  "Hide details": "Hide details",
  "Hide details for {name}": "Hide details for {name}",
  "High": "High",
  "High Risk": "High Risk",
  "High must be greater than low.": "High must be greater than low.",
  "Highlights data points that deviate significantly from the mean": "Highlights data points that deviate significantly from the mean",
  "History": "History",
  "Home": "Home",
  "How far along are we with the EU AI Act?": "How far along are we with the EU AI Act?",
  "How many we need:": "How many we need:",
  "How much could this cost if it happens?": "How much could this cost if it happens?",
  "How often does this happen?": "How often does this happen?",
  "How ready are we for the EU AI Act?": "How ready are we for the EU AI Act?",
  "I have read and understood this policy": "I have read and understood this policy",
  "IN SCOPE CONTROLS": "IN SCOPE CONTROLS",
  "IN SCOPE REQUIREMENTS": "IN SCOPE REQUIREMENTS",
  "If the problem persists please": "If the problem persists please",
  "If the system is already in use, enter the date it went live, as best you know it.": "If the system is already in use, enter the date it went live, as best you know it.",
  "If this is a mistake, please contact your organization administrator": "If this is a mistake, please contact your organization administrator",
  "If you don't see it within a few minutes, check your spam folder.": "If you don't see it within a few minutes, check your spam folder.",
  "If you go back you will lose the current information.": "If you go back you will lose the current information.",
  "If you run the AI Agent you will lose the current information.": "If you run the AI Agent you will lose the current information.",
  "Impact": "Impact",
  "Implied mean": "Implied mean",
  "Implied median": "Implied median",
  "Important Notice:": "Important Notice:",
  "Importer": "Importer",
  "In Progress": "In Progress",
  "In Review": "In Review",
  "In order to have a compliant AI use the suggested frameworks.": "In order to have a compliant AI use the suggested frameworks.",
  "In the Keys section of the same page, create a key with the read scopes read:compliance_activities, read:compliance_org_data and read:compliance_user_data. Do not select delete:compliance_user_data": "In the Keys section of the same page, create a key with the read scopes read:compliance_activities, read:compliance_org_data and read:compliance_user_data. Do not select delete:compliance_user_data",
  "In the meantime you can access our": "In the meantime you can access our",
  "In-App": "In-App",
  "In-app notifications are always on.": "In-app notifications are always on.",
  "In-app notifications for all platform events. Always enabled - the baseline channel for every user.": "In-app notifications for all platform events. Always enabled - the baseline channel for every user.",
  "Inactive": "Inactive",
  "Include archived": "Include archived",
  "Include internal organizations": "Include internal organizations",
  "Include out of scope": "Include out of scope",
  "Independent of graph filters": "Independent of graph filters",
  "Indexing": "Indexing",
  "Individual data points as a scatter plot": "Individual data points as a scatter plot",
  "Info": "Info",
  "Initial state.": "Initial state.",
  "Input": "Input",
  "Input uncertainty is not propagated; the simulation varies outcomes given selected parameters.": "Input uncertainty is not propagated; the simulation varies outcomes given selected parameters.",
  "Insert Description": "Insert Description",
  "Insert Email": "Insert Email",
  "Insert Last Name": "Insert Last Name",
  "Insert Name": "Insert Name",
  "Insert Placeholder": "Insert Placeholder",
  "Insert URL": "Insert URL",
  "Insert Value": "Insert Value",
  "Insert a monetary value": "Insert a monetary value",
  "Insert description": "Insert description",
  "Insert job title": "Insert job title",
  "Insert placeholder label": "Enter placeholder label",
  "Insert text": "Insert text",
  "Inside European Union": "Inside European Union",
  "Inside the limit": "Inside the limit",
  "Inspect the provider invocations behind the usage breakdown.": "Inspect the provider invocations behind the usage breakdown.",
  "Intangible": "Intangible",
  "Integration Source removed successfully!": "Integration Source removed successfully!",
  "Integration Source updated successfully!": "Integration Source updated successfully!",
  "Integration Support": "Integration Support",
  "Integration Type": "Integration Type",
  "Intended Purpose": "Intended Purpose",
  "Intended Use": "Intended Use",
  "Interacts with external customers": "Interacts with external customers",
  "Internal": "Internal",
  "Internal organizations are excluded from AI usage metrics by default.": "Internal organizations are excluded from AI usage metrics by default.",
  "Introduction": "Introduction",
  "Invalid subscription ID format: {ids}. Expected GUID format.": "Invalid subscription ID format: {ids}. Expected GUID format.",
  "Investigation Complete": "Investigation Complete",
  "Investigator Findings": "Investigator Findings",
  "Invitation Expired": "Invitation Expired",
  "Invitation Expires At": "Invitation Expires At",
  "Invitation Sent": "Invitation Sent",
  "Invitation to “{name}“ is successfully cancelled.": "Invitation to “{name}“ is successfully cancelled.",
  "Invitation to “{name}“ is successfully resent.": "Invitation to “{name}“ is successfully resent.",
  "Invite User": "Invite User",
  "Invited": "Invited",
  "Inviting another person is blocked until the limit is raised, or an existing one is removed.": "Inviting another person is blocked until the limit is raised, or an existing one is removed.",
  "Iterations": "Iterations",
  "JP¥ - Japanese Yen (JPY)": "JP¥ - Japanese Yen (JPY)",
  "Job": "Job",
  "Job Title": "Job Title",
  "Job created": "Job created",
  "Job created and run started": "Job created and run started",
  "Job disabled": "Job disabled",
  "Job enabled": "Job enabled",
  "Job name": "Job name",
  "Job scheduled": "Job scheduled",
  "Job title (optional)": "Job title (optional)",
  "Job updated": "Job updated",
  "Jobs": "Jobs",
  "Key Assumptions": "Key Assumptions",
  "Key rejected": "Key rejected",
  "Known amount: band width and dot size": "Known amount: band width and dot size",
  "Langfuse API URL*": "Langfuse API URL*",
  "Language": "Language",
  "Last Name": "Last Name",
  "Last Result": "Last Result",
  "Last Run": "Last Run",
  "Last Tested": "Last Tested",
  "Last Updated": "Last Updated",
  "Last Updated:": "Last Updated:",
  "Last access": "Last access",
  "Last assessed": "Last assessed",
  "Last assessment {date}": "Last assessment {date}",
  "Last quantified {date}": "Last quantified {date}",
  "Last run failed {when}": "Last run failed {when}",
  "Last update": "Last update",
  "Last updated": "Last updated",
  "Last {tab} controls": "Last {tab} controls",
  "Latest": "Latest",
  "Latest Version": "Latest Version",
  "Latest run": "Latest run",
  "Latest verdict": "Latest verdict",
  "Layers": "Layers",
  "Leave empty for random": "Leave empty for random",
  "Leave empty to access all projects": "Leave empty to access all projects",
  "Leave empty to access all schemas": "Leave empty to access all schemas",
  "Leave empty to use Anthropic's API.": "Leave empty to use Anthropic's API.",
  "Leave empty to use the default role": "Leave empty to use the default role",
  "Legal basis": "Legal basis",
  "Less than or equal to": "Less than or equal to",
  "Lifecycle": "Lifecycle",
  "Lifecycle Stage": "Lifecycle Stage",
  "Likelihood": "Likelihood",
  "Likelihood × impact matrix approach": "Likelihood × impact matrix approach",
  "Limit": "Limit",
  "Limit Utilization": "Limit Utilization",
  "Limit exceeded": "Limit exceeded",
  "Limit increase request - {organization}": "Limit increase request - {organization}",
  "Limit reached": "Limit reached",
  "Limit: sum of the limits of the AI Systems you can see": "Limit: sum of the limits of the AI Systems you can see",
  "Limits are set per organization. Contact Sales to change one.": "Limits are set per organization. Contact Sales to change one.",
  "Lines {from}-{to}": "Lines {from}-{to}",
  "Load more": "Load more",
  "Loading the graph…": "Loading the graph…",
  "Loading the risk flow…": "Loading the risk flow…",
  "Loading...": "Loading...",
  "Location affects which obligations apply and whether an Authorised Representative is needed.": "Location affects which obligations apply and whether an Authorised Representative is needed.",
  "Log": "Log",
  "Logarithmic scale — useful for large value ranges": "Logarithmic scale — useful for large value ranges",
  "Login": "Login",
  "Logout": "Logout",
  "Logs list is empty": "Logs list is empty",
  "Looking for Scout's access to documents and code?": "Looking for Scout's access to documents and code?",
  "Looking for shared data feeds for tests and monitoring?": "Looking for shared data feeds for tests and monitoring?",
  "Loss at p99": "Loss at p99",
  "Loss distribution": "Loss distribution",
  "Loss distribution preview from credible-low and credible-high inputs": "Loss distribution preview from credible-low and credible-high inputs",
  "Loss magnitude": "Loss magnitude",
  "Low": "Low",
  "Low must be less than high.": "Low must be less than high.",
  "Low relevance": "Low relevance",
  "MC standard error: {pct}% of EAL": "MC standard error: {pct}% of EAL",
  "Main menu": "Main menu",
  "Makes an AI system available on the market without affecting its properties, other than the provider or importer.": "Makes an AI system available on the market without affecting its properties, other than the provider or importer.",
  "Manage AI System risk limits and review current risk values.": "Manage AI System risk limits and review current risk values.",
  "Manage Connectors": "Manage Connectors",
  "Manage Sources": "Manage Sources",
  "Manage Systems": "Manage Systems",
  "Manage Users": "Manage Users",
  "Manage source connectors": "Manage source connectors",
  "Manual Entry": "Manual Entry",
  "Manual Entry Details": "Manual Entry Details",
  "Manual Override Limit": "Manual Override Limit",
  "Manual Override Value": "Manual Override Value",
  "Manual Override limit.": "Manual Override Limit.",
  "Manual setup": "Manual setup",
  "Mapped Controls": "Mapped Controls",
  "Mapped Frameworks": "Mapped Frameworks",
  "Mapped Requirement(s)": "Mapped Requirement(s)",
  "Mapped Requirements": "Mapped Requirements",
  "Mapped by": "Mapped by",
  "Mark as Fulfilled": "Mark as Fulfilled",
  "Mark as read": "Mark as read",
  "Mark this control as Out of Scope": "Mark this control as Out of Scope",
  "Matrix with scenario-based adjustments": "Matrix with scenario-based adjustments",
  "Max {count} file(s), {size}MB each.": "Max {count} file(s), {size}MB each.",
  "Maximum 100,000 trials allowed": "Maximum 100,000 trials allowed",
  "Maximum acceptable risk threshold for this AI System, auto-calculated by your organization's method. Can be manually overridden.": "Maximum acceptable risk threshold for this AI System, auto-calculated by your organization's method. Can be manually overridden.",
  "Maximum file size {size}MB": "Maximum file size {size}MB",
  "Maximum file size {size}MB. Accepted formats pdf, doc, txt and html.": "Maximum file size {size}MB. Accepted formats pdf, doc, txt and html.",
  "Maximum {max} characters allowed": "Maximum {max} characters allowed",
  "Median": "Median",
  "Mentioned": "Mentioned",
  "Method": "Method",
  "Method Used": "Method Used",
  "Methodology": "Methodology",
  "Metric": "Metric",
  "Metric Test": "Metric Test",
  "Metric is valid": "Metric is valid",
  "Metric not found": "Metric not found",
  "Metric*": "Metric*",
  "Metric:": "Metric:",
  "Metrics Overview": "Metrics Overview",
  "Microsoft Teams": "Microsoft Teams",
  "Minimal Risk": "Minimal Risk",
  "Minimize (your chat stays)": "Minimize (your chat stays)",
  "Minimize Scout": "Minimize Scout",
  "Minimum 1 trial required": "Minimum 1 trial required",
  "Missing required condition data": "Missing required condition data",
  "Missing required parameters from OAuth callback": "Missing required parameters from OAuth callback",
  "Missing scope": "Missing scope",
  "Mitigation": "Mitigation",
  "Model": "Model",
  "Model Card": "Model Card",
  "Model Property": "Model Property",
  "Model Supply Terms": "Model Supply Terms",
  "Model assumptions": "Model assumptions",
  "Models": "Models",
  "Modification Support": "Modification Support",
  "Modified": "Modified",
  "Modified By": "Modified By",
  "Modified {date}": "Modified {date}",
  "Modules": "Modules",
  "Modules list is empty": "Modules list is empty",
  "Modulos AG": "Modulos AG",
  "Modulos Employee": "Modulos Employee",
  "Modulos home": "Modulos home",
  "Modulos only reads; it never changes or deletes anything in your Claude organization. read:compliance_user_data is needed for the user directory.": "Modulos only reads; it never changes or deletes anything in your Claude organization. read:compliance_user_data is needed for the user directory.",
  "Monitor token consumption and estimated costs across all organizations.": "Monitor token consumption and estimated costs across all organizations.",
  "Monte Carlo Simulation": "Monte Carlo Simulation",
  "Monthly": "Monthly",
  "Monthly at {time}, from {date}": "Monthly at {time}, from {date}",
  "Monthly cost limit": "Monthly cost limit",
  "Monthly on the {ordinal} {weekday}": "Monthly on the {ordinal} {weekday}",
  "More actions for {title}": "More actions for {title}",
  "Move Policy to Draft": "Move Policy to Draft",
  "Move to Draft": "Move to Draft",
  "Multiple times": "Multiple times",
  "My Role(s)": "My Role(s)",
  "My Submissions": "My Submissions",
  "My Tasks": "My Tasks",
  "NEW": "NEW",
  "Name": "Name",
  "Name is required": "Name is required",
  "Name is required.": "Name is required.",
  "Namespace:": "Namespace:",
  "Nature": "Nature",
  "Need Approval": "Need Approval",
  "New AI System": "New AI System",
  "New Agent Test": "New Agent Test",
  "New Asset": "New Asset",
  "New Chat": "New Chat",
  "New Document": "New Document",
  "New Evidence": "New Evidence",
  "New Integration Source successfully connected!": "New Integration Source successfully connected!",
  "New Policy": "New Policy",
  "New Policy Template": "New Policy Template",
  "New Risk": "New Risk",
  "New Template": "New Template",
  "New Test": "New Test",
  "New Token": "New Token",
  "New User": "New User",
  "New Vendor": "New Vendor",
  "New chat about it": "New chat about it",
  "New conversation": "New conversation",
  "New name for {name}": "New name for {name}",
  "Next": "Next",
  "Next Review Date": "Next Review Date",
  "Next run": "Next run",
  "No": "No",
  "No AI System Role(s)": "No AI System Role(s)",
  "No AI Systems found.": "No AI Systems found.",
  "No AI Systems found. Click the New AI System button to create your first AI System.": "No AI Systems found. Click the New AI System button to create your first AI System.",
  "No AI Systems to show": "No AI Systems to show",
  "No AI Systems with risk value found.": "No AI Systems with risk value found.",
  "No AI prices configured.": "No AI prices configured.",
  "No AI usage quota is configured for this organization.": "No AI usage quota is configured for this organization.",
  "No AI usage recorded for this period.": "No AI usage recorded for this period.",
  "No EU AI Act details have been provided yet.": "No EU AI Act details have been provided yet.",
  "No Jobs": "No Jobs",
  "No Quantified Risks": "No Quantified Risks",
  "No Risk Values yet": "No Risk Values yet",
  "No acknowledgement history available.": "No acknowledgement history available.",
  "No acknowledgment data available.": "No acknowledgment data available.",
  "No additional details available for this method.": "No additional details available for this method.",
  "No comments or logs yet": "No comments or logs yet",
  "No concept types found": "No concept types found",
  "No connectors configured": "No connectors configured",
  "No content available.": "No content available.",
  "No content provided.": "No content provided.",
  "No controls assessed yet": "No controls assessed yet",
  "No conversations here yet.": "No conversations here yet.",
  "No conversations match \"{query}\"": "No conversations match \"{query}\"",
  "No conversations match \"{query}\" in {scope}": "No conversations match \"{query}\" in {scope}",
  "No conversations yet": "No conversations yet",
  "No cost limit set": "No cost limit set",
  "No data found for this concept.": "No data found for this concept.",
  "No description available": "No description available",
  "No description provided.": "No description provided.",
  "No distribution data available for this run.": "No distribution data available for this run.",
  "No environments found": "No environments found",
  "No environments selected": "No environments selected",
  "No evaluation data found. Run an evaluation in Vijil first.": "No evaluation data found. Run an evaluation in Vijil first.",
  "No evidence provided": "No evidence provided",
  "No findings to display": "No findings to display",
  "No frameworks attached yet": "No frameworks attached yet",
  "No gap(s) found.": "No gap(s) found.",
  "No grouping": "No grouping",
  "No items": "No items",
  "No items match your search": "No items match your search",
  "No key": "No key",
  "No limit": "No limit",
  "No linked tests": "No linked tests",
  "No longer available": "No longer available",
  "No matches": "No matches",
  "No matches for \"{search}\"": "No matches for \"{search}\"",
  "No metrics available for this resource": "No metrics available for this resource",
  "No metrics available for this source": "No metrics available for this source",
  "No more AI Systems can be created on your current plan.": "No more AI Systems can be created on your current plan.",
  "No new updates in {n}d": "No new updates in {n}d",
  "No organization": "No organization",
  "No policies assigned.": "No policies assigned.",
  "No policies available.": "No policies available.",
  "No policies linked": "No policies linked",
  "No policy templates available.": "No policy templates available.",
  "No preview available": "No preview available",
  "No quantification data": "No quantification data",
  "No quantification data available.": "No quantification data available.",
  "No quantification results yet": "No quantification results yet",
  "No recommendations available.": "No recommendations available.",
  "No references found.": "No references found.",
  "No repositories found": "No repositories found",
  "No resources found": "No resources found",
  "No results": "No results",
  "No results for your search.": "No results for your search.",
  "No results found.": "No results found.",
  "No risk limit": "No risk limit",
  "No risks found": "No risks found",
  "No risks recorded yet": "No risks recorded yet",
  "No runs yet": "No runs yet",
  "No runs yet. Press Run Now to start one.": "No runs yet. Press Run Now to start one.",
  "No scope changes will be applied.": "No scope changes will be applied.",
  "No shared controls": "No shared controls",
  "No steps yet": "No steps yet",
  "No templates available.": "No templates available.",
  "No tests found": "No tests found",
  "No threats": "No threats",
  "No threats yet": "No threats yet",
  "No usage events recorded for this period.": "No usage events recorded for this period.",
  "No usage in this period.": "No usage in this period.",
  "Non-FOSS": "Non-FOSS",
  "None": "None",
  "Not Executed": "Not Executed",
  "Not Fulfilled": "Not Fulfilled",
  "Not applicable": "Not applicable",
  "Not assessed": "Not assessed",
  "Not assessed yet": "Not assessed yet",
  "Not checked": "Not checked",
  "Not checked yet.": "Not checked yet.",
  "Not configured": "Not configured",
  "Not enabled": "Not enabled",
  "Not quantified": "Not quantified",
  "Not set": "Not set",
  "Not sure": "Not sure",
  "Note:": "Note:",
  "Nothing is shown rather than part of it. Turn off a layer to load less.": "Nothing is shown rather than part of it. Turn off a layer to load less.",
  "Nothing is shown until the whole graph loads, so you never see only part of it.": "Nothing is shown until the whole graph loads, so you never see only part of it.",
  "Nothing matches \"{query}\". Scout lists only the AI Systems you have access to.": "Nothing matches \"{query}\". Scout lists only the AI Systems you have access to.",
  "Nothing matches these filters": "Nothing matches these filters",
  "Nothing matches “{query}”.": "Nothing matches “{query}”.",
  "Nothing to quantify yet.": "Nothing to quantify yet.",
  "Nothing to show": "Nothing to show",
  "Notification": "Notification",
  "Notification Preferences": "Notification Preferences",
  "Notification preferences saved.": "Notification preferences saved.",
  "Notification settings saved successfully.": "Notification settings saved successfully.",
  "Notification updated as {status} successfully": "Notification updated as {status} successfully",
  "Notifications": "Notifications",
  "Notifications Center": "Notifications Center",
  "Notify your team via Google Chat spaces and direct messages.": "Notify your team via Google Chat spaces and direct messages.",
  "Number": "Number",
  "Number of trials": "Number of trials",
  "Of limit": "Of limit",
  "Off (default): Modulos reads only metadata, meaning who, when, which product and model, and counts.": "Off (default): Modulos reads only metadata, meaning who, when, which product and model, and counts.",
  "Older": "Older",
  "On the same page, create a key with the read:analytics scope for adoption and cost": "On the same page, create a key with the read:analytics scope for adoption and cost",
  "On: everyone with access to this AI System can have Scout and Agent Tests read messages, files and titles. These can contain personal and confidential data.": "On: everyone with access to this AI System can have Scout and Agent Tests read messages, files and titles. These can contain personal and confidential data.",
  "Onboard, manage and monitor AI vendors.": "Onboard, manage and monitor AI vendors.",
  "Once at most": "Once at most",
  "Once-at-most mode: zero or one annual occurrence (Bernoulli).": "Once-at-most mode: zero or one annual occurrence (Bernoulli).",
  "One-time": "One-time",
  "Only": "Only",
  "Only Owners and organization admins can change this. Every change is recorded in the AI System's activity log.": "Only Owners and organization admins can change this. Every change is recorded in the AI System's activity log.",
  "Only Policy Managers can reassign policy ownership.": "Only Policy Managers can reassign policy ownership.",
  "Only those risks where all threat vectors have been quantified are shown here.": "Only those risks where all threat vectors have been quantified are shown here.",
  "Open AI System": "Open AI System",
  "Open Draft": "Open Draft",
  "Open Power Platform admin center": "Open Power Platform admin center",
  "Open Risk": "Open Risk",
  "Open Scout": "Open Scout",
  "Open in new tab": "Open in new tab",
  "Open menu": "Open menu",
  "Open setup link": "Open setup link",
  "Open {item}": "Open {item}",
  "Open {name}": "Open {name}",
  "Operation": "Operation",
  "Operator": "Operator",
  "Operator*": "Operator*",
  "Optional. Leave empty to connect the whole tenant and pick its environments above. For a single environment, open Manage > Environments in the Power Platform admin center and copy its Environment URL.": "Optional. Leave empty to connect the whole tenant and pick its environments above. For a single environment, open Manage > Environments in the Power Platform admin center and copy its Environment URL.",
  "Org AI Systems": "Org AI Systems",
  "Organization": "Organization",
  "Organization AI System description placeholder": "Write a brief description of this AI System to help our AI agents understand what context you operate in. You can leave this blank if you only have one organization AI System as the description is set under Organization> Settings. If this organization AI System has a specific scope (e.g. a particular certification, or sub-unit of your organization), describe it here.\n",
  "Organization AI Systems": "Organization AI Systems",
  "Organization Admin": "Organization Admin",
  "Organization Currency": "Organization Currency",
  "Organization Description": "Organization Description",
  "Organization Description Placeholder": "Write a brief description of your organization to help our AI agents understand what context you operate in. The following information would be helpful:\nWhat business your organization is in\n\t- What products or services your offer\n\t- What countries or regions you operate in\n\t- Key figures such as how many employees you have what your revenue is\n\t- Anything else that would help the agents assist you",
  "Organization Establishment": "Organization Establishment",
  "Organization ID": "Organization ID",
  "Organization Method (Read-only)": "Organization Method (Read-only)",
  "Organization Name": "Organization Name",
  "Organization Policy Manager": "Organization Policy Manager",
  "Organization Profile": "Organization Profile",
  "Organization Registration Manager": "Organization Registration Manager",
  "Organization Risk Manager": "Organization Risk Manager",
  "Organization Roles": "Organization Roles",
  "Organization Settings": "Organization Settings",
  "Organization configuration updated successfully": "Organization configuration updated successfully",
  "Organization settings": "Organization settings",
  "Organization usage": "Organization usage",
  "Organization: {organization} (ID: {organizationId})": "Organization: {organization} (ID: {organizationId})",
  "Organizational AI Systems": "Organizational AI Systems",
  "Organizational AI Systems list is empty.": "Organizational AI Systems list is empty.",
  "Organizations": "Organizations",
  "Organizations list is empty": "Organizations list is empty",
  "Organizations, roles and groups": "Organizations, roles and groups",
  "Other": "Other",
  "Other AI Systems · recent first": "Other AI Systems · recent first",
  "Other groups": "Other groups",
  "Out of Scope": "Out of Scope",
  "Out of Scope Controls": "Out of Scope Controls",
  "Out of Scope Requirements": "Out of Scope Requirements",
  "Out of scope: non-EU, or not an AI system": "Out of scope: non-EU, or not an AI system",
  "Outdated": "Outdated",
  "Outliers": "Outliers",
  "Output": "Output",
  "Outside of European Union": "Outside of European Union",
  "Over limit ({count})": "Over limit ({count})",
  "Over the limit": "Over the limit",
  "Overall Compliance": "Overall Compliance",
  "Override with manual value": "Override with manual value",
  "Overview": "Overview",
  "Owner": "Owner",
  "Owner(s)": "Owner(s)",
  "PDF document selected": "PDF document selected",
  "PDF up to 100 MB": "PDF up to 100 MB",
  "PREVIEW": "PREVIEW",
  "Page not found": "Page not found",
  "Part of a product you ship": "Part of a product you ship",
  "Partial": "Partial",
  "Partly quantified: fill = share of threats": "Partly quantified: fill = share of threats",
  "Partly: share of its controls executed": "Partly: share of its controls executed",
  "Partner": "Partner",
  "Pass Criteria": "Pass Criteria",
  "Passed": "Passed",
  "Passed Tests": "Passed Tests",
  "Password reset email sent to {name}": "Password reset email sent to {name}",
  "Pending": "Pending",
  "Pending Invitation": "Pending Invitation",
  "Pending Invitations": "Pending Invitations",
  "Pending Policies": "Pending Policies",
  "Pending Review: ": "Pending Review: ",
  "Pending invitations count until they are accepted or expire. Modulos staff are not counted.": "Pending invitations count until they are accepted or expire. Modulos staff are not counted.",
  "Per Policy": "Per Policy",
  "Per User": "Per User",
  "Per-event loss curve. Frequency combines with this on the result page.": "Per-event loss curve. Frequency combines with this on the result page.",
  "Performed By": "Performed By",
  "Period": "Period",
  "Personal": "Personal",
  "Personal Access Token": "Personal Access Token",
  "Pick Files": "Pick Files",
  "Pick the environments to read agent details from. Agent counts for the whole tenant need no setup.": "Pick the environments to read agent details from. Agent counts for the whole tenant need no setup.",
  "Pilot": "Pilot",
  "Places on the EU market an AI system that bears the name or trademark of a person established outside the EU.": "Places on the EU market an AI system that bears the name or trademark of a person established outside the EU.",
  "Platform Default": "Platform Default",
  "Platform Notifications": "Platform Notifications",
  "Please": "Please",
  "Please Select": "Please Select",
  "Please Select something": "Please Select something",
  "Please contact your administrator to invite you to join the organization": "Please contact your administrator to invite you to join the organization",
  "Please enter a valid AWS region (e.g., us-east-1)": "Please enter a valid AWS region (e.g., us-east-1)",
  "Please enter a valid Azure client ID (GUID format)": "Please enter a valid Azure client ID (GUID format)",
  "Please enter a valid Azure tenant ID (GUID format)": "Please enter a valid Azure tenant ID (GUID format)",
  "Please enter a valid GitHub repository URL": "Please enter a valid GitHub repository URL",
  "Please enter a valid email address": "Please enter a valid email address",
  "Please enter a valid server URL": "Please enter a valid server URL",
  "Please fill in the dataset card/model card information.": "Please fill in the dataset card/model card information.",
  "Please provide a reason": "Please provide a reason",
  "Please provide a reason to reject the policy approval request.": "Please provide a reason to reject the policy approval request.",
  "Please provide a reason to the status change and further comments to successfully execute it.": "Please provide a reason to the status change and further comments to successfully execute it.",
  "Please read and accept our": "Please read and accept our",
  "Please run the AI Agent to generate the Assessment for this Control.": "Please run the AI Agent to generate the Assessment for this Control.",
  "Please select": "Please select",
  "Please select a lifecycle stage": "Please select a lifecycle stage",
  "Please select a type": "Please select a type",
  "Please select something": "Please select something",
  "Please type metric name": "Please type metric name",
  "Please type something": "Please type something",
  "Please upload a new framework in organization settings section.": "Please upload a new framework in organization settings section.",
  "Plugins and marketplaces": "Plugins and marketplaces",
  "Poisson · events per year": "Poisson · events per year",
  "Policies": "Policies",
  "Policy": "Policy",
  "Policy Acknowledgments": "Policy Acknowledgments",
  "Policy Center": "Policy Center",
  "Policy Management": "Policy Management",
  "Policy Name": "Policy Name",
  "Policy Name*": "Policy Name*",
  "Policy Template": "Policy Template",
  "Policy Template Name*": "Policy Template Name*",
  "Policy Templates": "Policy Templates",
  "Policy Version": "Policy Version",
  "Policy acknowledged": "Policy acknowledged",
  "Policy acknowledged successfully": "Policy acknowledged successfully",
  "Policy acknowledgment": "Policy acknowledgment",
  "Policy details saved": "Policy details saved",
  "Policy exported successfully": "Policy exported successfully",
  "Policy has been archived": "Policy has been archived",
  "Policy has been unarchived": "Policy has been unarchived",
  "Policy linked successfully": "Policy linked successfully",
  "Policy name is required": "Policy name is required",
  "Policy not found": "Policy not found",
  "Policy owner was updated": "Policy owner was updated",
  "Policy removed from control": "Policy removed from control",
  "Policy template details saved": "Policy template details saved",
  "Policy template has been archived": "Policy template has been archived",
  "Policy template has been unarchived": "Policy template has been unarchived",
  "Policy template name is required": "Policy template name is required",
  "Policy template not found": "Policy template not found",
  "Policy template version was published": "Policy template version was published",
  "Policy template {name} created successfully": "Policy template {name} created successfully",
  "Policy version not found": "Policy version not found",
  "Policy version was published": "Policy version was published",
  "Policy {name} created successfully": "Policy {name} created successfully",
  "Portfolio": "Portfolio",
  "Postal Code": "Postal Code",
  "Pre-selected from your answers. You can add or change frameworks later in the AI System settings.": "Pre-selected from your answers. You can add or change frameworks later in the AI System settings.",
  "Preview": "Preview",
  "Preview Changes": "Preview Changes",
  "Preview Scope Changes": "Preview Scope Changes",
  "Previous": "Previous",
  "Privacy & Policy": "Privacy & Policy",
  "Privacy Policy": "Privacy Policy",
  "Privacy Policy URL": "Privacy Policy URL",
  "Probabilistic simulation approach": "Probabilistic simulation approach",
  "Probability": "Probability",
  "Probability of exceeding": "Probability of exceeding",
  "Probe": "Probe",
  "Processing authorization...": "Processing authorization...",
  "Processing document…": "Processing document…",
  "Processing failed": "Processing failed",
  "Product Category": "Product Category",
  "Product Category and Role are required; the rest can be completed in the AI System settings later.": "Product Category and Role are required; the rest can be completed in the AI System settings later.",
  "Programmatic Access Token is required": "Programmatic Access Token is required",
  "Programmatic Access Token*": "Programmatic Access Token*",
  "Progress": "Progress",
  "Progress breakdown": "Progress breakdown",
  "Prohibited AI Practices (Article 5)": "Prohibited AI Practices (Article 5)",
  "Prohibited AI System": "Prohibited AI System",
  "Project": "Project",
  "Project ID (Optional)": "Project ID (Optional)",
  "Prompts": "Prompts",
  "Proposed": "Proposed",
  "Proposed means the system is an idea or a request, not yet tested. Pilot means a limited trial with real users or real data. Your answer determines which checks come first, so describe what actually exists, not what should exist.": "Proposed means the system is an idea or a request, not yet tested. Pilot means a limited trial with real users or real data. Your answer determines which checks come first, so describe what actually exists, not what should exist.",
  "Protocol": "Protocol",
  "Provide Feedback": "Provide Feedback",
  "Provider": "Provider",
  "Public Key is required": "Public Key is required",
  "Public Key*": "Public Key*",
  "Publish": "Publish",
  "Publish Policy": "Publish Policy",
  "Publish Policy Template": "Publish Policy Template",
  "Published": "Published",
  "Published At": "Published At",
  "Published By": "Published By",
  "Purpose, technology and intended users.": "Purpose, technology and intended users.",
  "PwC Partner": "PwC Partner",
  "QR code": "QR code",
  "Quantification": "Quantification",
  "Quantification History": "Quantification History",
  "Quantification considers industry benchmarks and threat intelligence": "Quantification considers industry benchmarks and threat intelligence",
  "Quantification in progress": "Quantification in progress",
  "Quantification in progress...": "Quantification in progress...",
  "Quantification is being processed. Results will appear automatically.": "Quantification is being processed. Results will appear automatically.",
  "Quantified": "Quantified",
  "Quantified At": "Quantified At",
  "Quantified Value": "Quantified Value",
  "Quantifier Math": "Quantifier Math",
  "Quantify": "Quantify",
  "Quantify Threat Vectors to fill the map.": "Quantify Threat Vectors to fill the map.",
  "Quarterly": "Quarterly",
  "Question": "Question",
  "Questionnaire progress is saved.": "Questionnaire progress is saved.",
  "Questionnaire will be restarted and the answers already provided will be lost.": "Restarting the questionnaire will erase all current answers.",
  "Queued": "Queued",
  "Quota disabled": "Quota disabled",
  "Quota used": "Quota used",
  "Random Seed": "Random Seed",
  "Range": "Range",
  "Ranked by estimated cost. Select an organization to investigate its usage.": "Ranked by estimated cost. Select an organization to investigate its usage.",
  "Raw distribution parameters": "Raw distribution parameters",
  "Re-authorize this connector with new credentials": "Re-authorize this connector with new credentials",
  "Re-take Questionnaire": "Re-take Questionnaire",
  "Readiness": "Readiness",
  "Reads messages and files": "Reads messages and files",
  "Ready to sign off": "Ready to sign off",
  "Reason for approval": "Reason for approval",
  "Reason for rejection": "Reason for rejection",
  "Reauthenticate": "Reauthenticate",
  "Reauthenticate to disable 2FA": "Reauthenticate to disable 2FA",
  "Recalculate": "Recalculate",
  "Recent AI Systems": "Recent AI Systems",
  "Recommendations": "Recommendations",
  "Reconnect": "Reconnect",
  "Recorded in the AI System's activity log with your name. At least 5 characters.": "Recorded in the AI System's activity log with your name. At least 5 characters.",
  "Records per page:": "Records per page:",
  "Recurring mode: independent annual event counts with constant rate (Poisson — equidispersion).": "Recurring mode: independent annual event counts with constant rate (Poisson — equidispersion).",
  "References": "References",
  "References & Methodology": "References & Methodology",
  "Reflects the latest assessment of each control": "Reflects the latest assessment of each control",
  "Refresh": "Refresh",
  "Region is required": "Region is required",
  "Region*": "Region*",
  "Register one entry per distinct use: the same tool used for two very different purposes may need two entries, because risk classification depends on what the system is used for, not just what it is.": "Register one entry per distinct use: the same tool used for two very different purposes may need two entries, because risk classification depends on what the system is used for, not just what it is.",
  "Registering another one is blocked until the limit is raised, or an existing one is removed.": "Registering another one is blocked until the limit is raised, or an existing one is removed.",
  "Registration Status": "Registration Status",
  "Reject": "Reject",
  "Reject AI System": "Reject AI System",
  "Reject Policy Approval Request": "Reject Policy Approval Request",
  "Rejected": "Rejected",
  "Related": "Related",
  "Related requirements": "Related requirements",
  "Release Notes": "Release Notes",
  "Relevant": "Relevant",
  "Relevant findings": "Relevant findings",
  "Remove": "Remove",
  "Remove Risk": "Remove Risk",
  "Remove Source": "Remove Source",
  "Remove Threat": "Remove Threat",
  "Remove a filter or turn a layer back on to see more.": "Remove a filter or turn a layer back on to see more.",
  "Remove authenticator app": "Remove authenticator app",
  "Remove two-factor authentication": "Remove two-factor authentication",
  "Remove user from AI System": "Remove user from AI System",
  "Remove {name}": "Remove {name}",
  "Removing this risk will remove it from the threat. This action cannot be undone. Do you want to continue?": "Removing this risk will remove it from the threat. This action cannot be undone. Do you want to continue?",
  "Removing this threat will remove it from the risk. This action cannot be undone. Do you want to continue?": "Removing this threat will remove it from the risk. This action cannot be undone. Do you want to continue?",
  "Rename": "Rename",
  "Rename {name}": "Rename {name}",
  "Rename {title}": "Rename {title}",
  "Renewal At": "Renewal At",
  "Renewal Period": "Renewal Period",
  "Repeats": "Repeats",
  "Replace": "Replace",
  "Replace All": "Replace All",
  "Report": "Report",
  "Repository": "Repository",
  "Repository URL is required": "Repository URL is required",
  "Repository URL*": "Repository URL*",
  "Req. Status": "Req. Status",
  "Request Status Change for": "Request Status Change for",
  "Request a Limit Increase": "Request a Limit Increase",
  "Request status change": "Request status change",
  "Required": "Required",
  "Required because EU AI Act settings are filled in. Clear them in the previous step to deselect.": "Required because EU AI Act settings are filled in. Clear them in the previous step to deselect.",
  "Required for private repositories": "Required for private repositories",
  "Required — this notification cannot be disabled.": "Required — this notification cannot be disabled.",
  "Requirement": "Requirement",
  "Requirement code": "Requirement code",
  "Requirement is ready to be reviewed. If all related controls are correctly executed mark this requirement as Fulfilled.": "Requirement is ready to be reviewed. If all related controls are correctly executed mark this requirement as Fulfilled.",
  "Requirement marked as fulfilled": "Requirement marked as fulfilled",
  "Requirement owner was updated": "Requirement owner was updated",
  "Requirement status was updated": "Requirement status was updated",
  "Requirements": "Requirements",
  "Requirements list is empty": "Requirements list is empty",
  "Requirements moving IN scope": "Requirements moving IN scope",
  "Requirements moving OUT of scope": "Requirements moving OUT of scope",
  "Resend Invitation": "Resend Invitation",
  "Reset Password": "Reset Password",
  "Reset all controls to defaults": "Reset all controls to defaults",
  "Reset layout": "Reset layout",
  "Reset to suggested": "Reset to suggested",
  "Reset zoom": "Reset zoom",
  "Residual Risk": "Residual Risk",
  "Resize conversations": "Resize conversations",
  "Resource Group": "Resource Group",
  "Resource*": "Resource*",
  "Responsible Person": "Responsible Person",
  "Responsible Person*": "Responsible Person*",
  "Restart setup": "Restart setup",
  "Result": "Result",
  "Result Details": "Result Details",
  "Results": "Results",
  "Results include confidence intervals and explanations": "Results include confidence intervals and explanations",
  "Results list is empty": "Results list is empty",
  "Resume registration": "Resume registration",
  "Retry": "Retry",
  "Retry Upload": "Retry Upload",
  "Review": "Review",
  "Review Date": "Review Date",
  "Review Request": "Review Request",
  "Review approved": "Review approved",
  "Review assigned": "Review assigned",
  "Review cancelled": "Review cancelled",
  "Review rejected": "Review rejected",
  "Review the submission and approve it for use, or reject it.": "Review the submission and approve it for use, or reject it.",
  "Review(s) request for status change cancelled successfully": "Review(s) request for status change cancelled successfully",
  "Reviewer will help determine": "Reviewer will help determine",
  "Reviewer(s)": "Reviewer(s)",
  "Reviewer(s)*": "Reviewer(s)*",
  "Reviews": "Reviews",
  "Revoke": "Revoke",
  "Risk": "Risk",
  "Risk / Total Appetite": "Risk / Total Appetite",
  "Risk Agent": "Risk Agent",
  "Risk Agent Analysis": "Risk Agent Analysis",
  "Risk Agent will analyze the risk context using advanced AI models": "Risk Agent will analyze the risk context using advanced AI models",
  "Risk Calculation Formula": "Risk Calculation Formula",
  "Risk Category": "Risk Category",
  "Risk Category Limits should SUM up to 100% of 'Total Organization Risk Appetite'.": "Risk Category Limits should SUM up to 100% of 'Total Organization Risk Appetite'.",
  "Risk Change (%)": "Risk Change (%)",
  "Risk Description": "Risk Description",
  "Risk Distribution by Category": "Risk Distribution by Category",
  "Risk Level": "Risk Level",
  "Risk Level:": "Risk Level:",
  "Risk Limit": "Risk Limit",
  "Risk Limit {limit} · {percentage}% of limit": "Risk Limit {limit} · {percentage}% of limit",
  "Risk Limits": "Risk Limits",
  "Risk Management": "Risk Management",
  "Risk Management is not enabled for this AI System or you do not have permission to access it.": "Risk Management is not enabled for this AI System or you do not have permission to access it.",
  "Risk Matrix": "Risk Matrix",
  "Risk Name": "Risk Name",
  "Risk Name*": "Risk Name*",
  "Risk Overview": "Risk Overview",
  "Risk Quantification": "Risk Quantification",
  "Risk Score": "Risk Score",
  "Risk Status": "Risk Status",
  "Risk Status by Category": "Risk Status by Category",
  "Risk Taxonomy": "Risk Taxonomy",
  "Risk Utilization": "Risk Utilization",
  "Risk Value": "Risk Value",
  "Risk Value = Likelihood × Impact × Scaling Factor × Frequency": "Risk Value = Likelihood × Impact × Scaling Factor × Frequency",
  "Risk Value Over Time": "Risk Value Over Time",
  "Risk archived successfully": "Risk archived successfully",
  "Risk category archived successfully": "Risk category archived successfully",
  "Risk deleted successfully": "Risk deleted successfully",
  "Risk flow": "Risk flow",
  "Risk flow shows how quantified threats add up to this AI system's risk once risks are recorded.": "Risk flow shows how quantified threats add up to this AI system's risk once risks are recorded.",
  "Risk in {name}": "Risk in {name}",
  "Risk is required": "Risk is required",
  "Risk limits updated successfully": "Risk limits updated successfully",
  "Risk list is empty": "Risk list is empty",
  "Risk name is required": "Risk name is required",
  "Risk removed successfully": "Risk removed successfully",
  "Risk threat quantification started successfully": "Risk threat quantification started successfully",
  "Risk threshold": "Risk threshold",
  "Risk {name} created successfully": "Risk {name} created successfully",
  "Risk {name} updated successfully": "Risk {name} updated successfully",
  "Risk*": "Risk*",
  "Risks": "Risks",
  "Risks Identified": "Risks Identified",
  "Risks Overview": "Risks Overview",
  "Risks added successfully": "Risks added successfully",
  "Risks in this category": "Risks in this category",
  "Risks list is empty": "Risks list is empty",
  "Role": "Role",
  "Role (Optional)": "Role (Optional)",
  "Role missing": "Role missing",
  "Role too narrow": "Role too narrow",
  "Role(s)": "Role(s)",
  "Roles": "Roles",
  "Rows per page": "Rows per page",
  "Run": "Run",
  "Run Details": "Run Details",
  "Run Now": "Run Now",
  "Run Report": "Run Report",
  "Run Scope": "Run Scope",
  "Run it manually": "Run it manually",
  "Run manually": "Run manually",
  "Run on a schedule": "Run on a schedule",
  "Run quantifications to see the risk value trend over time.": "Run quantifications to see the risk value trend over time.",
  "Run queued. The report will appear in the runs list.": "Run queued. The report will appear in the runs list.",
  "Run started": "Run started",
  "Run stopped": "Run stopped",
  "Run your first quantification to see the results here.": "Run your first quantification to see the results here.",
  "Run {count} {unit}": "Run {count} {unit}",
  "Run “{name}” again?": "Run “{name}” again?",
  "Running": "Running",
  "Running daily at {time} {abbr}": "Running daily at {time} {abbr}",
  "Running monthly on the first day of the month at {time} {abbr}": "Running monthly on the first day of the month at {time} {abbr}",
  "Running quarterly at {time} {abbr}": "Running quarterly at {time} {abbr}",
  "Running weekly on Sundays at {time} {abbr}": "Running weekly on Sundays at {time} {abbr}",
  "Running, started {when}": "Running, started {when}",
  "Runs": "Runs",
  "Runs appear here once this Job executes.": "Runs appear here once this Job executes.",
  "Runs once on {date} at {time}": "Runs once on {date} at {time}",
  "Runtime Inspection": "Runtime Inspection",
  "SMA": "SMA",
  "SSO": "SSO",
  "SSO Status": "SSO Status",
  "SSO is not configured for this organization.": "SSO is not configured for this organization.",
  "Sample prompts": "Sample prompts",
  "Sampling": "Sampling",
  "Save": "Save",
  "Save Changes": "Save Changes",
  "Save answer as Temporary Evidence": "Save answer as Temporary Evidence",
  "Save changes": "Save changes",
  "Scaling Factor": "Scaling Factor",
  "Scenario": "Scenario",
  "Scenario Analysis": "Scenario Analysis",
  "Scenario Analysis Results": "Scenario Analysis Results",
  "Scenario Name": "Scenario Name",
  "Schedule": "Schedule",
  "Schedule Testing": "Schedule Testing",
  "Scheduled": "Scheduled",
  "Scheduled and running agent jobs for this AI system appear here.": "Scheduled and running agent jobs for this AI system appear here.",
  "Schema (Optional)": "Schema (Optional)",
  "Scope": "Scope",
  "Scope applied successfully": "Scope applied successfully",
  "Score:": "Score:",
  "Scout": "Scout",
  "Scout adds it to My Submissions as a Draft, with you as Owner. You finish the registration there.": "Scout adds it to My Submissions as a Draft, with you as Owner. You finish the registration there.",
  "Scout adds them to My Submissions as Drafts, with you as Owner. You finish each registration there.": "Scout adds them to My Submissions as Drafts, with you as Owner. You finish each registration there.",
  "Scout cannot read this type": "Scout cannot read this type",
  "Scout conversations": "Scout conversations",
  "Scout could not answer this question.": "Scout could not answer this question.",
  "Scout is still answering the previous question.": "Scout is still answering the previous question.",
  "Scout is still answering this conversation.": "Scout is still answering this conversation.",
  "Search": "Search",
  "Search AI Systems...": "Search AI Systems...",
  "Search Bitbucket": "Search Bitbucket",
  "Search GitHub": "Search GitHub",
  "Search all scopes": "Search all scopes",
  "Search by name or code…": "Search by name or code…",
  "Search conversations": "Search conversations",
  "Search for Controls": "Search for Controls",
  "Search for Integration": "Search for Integration",
  "Search for a Control": "Search for a Control",
  "Search for a user": "Search for a user",
  "Search for an evidence": "Search for an evidence",
  "Search looks at codes and names of requirements, controls, tests and threat vectors.": "Search looks at codes and names of requirements, controls, tests and threat vectors.",
  "Search looks at the names of threats, risks and categories.": "Search looks at the names of threats, risks and categories.",
  "Search metrics...": "Search metrics...",
  "Search policies...": "Search policies...",
  "Search queries:": "Search queries:",
  "Search requirements": "Search requirements",
  "Search resources...": "Search resources...",
  "Search results": "Search results",
  "Search scope": "Search scope",
  "Search templates...": "Search templates...",
  "Search threats, risks and categories…": "Search threats, risks and categories…",
  "Search users...": "Search users...",
  "Search...": "Search...",
  "Searched {count} sources": "Searched {count} sources",
  "Seat limit reached": "Seat limit reached",
  "Seats": "Seats",
  "Second framework": "Second framework",
  "Secret Access Key is required": "Secret Access Key is required",
  "Secret Access Key*": "Secret Access Key*",
  "Secret Key is required": "Secret Key is required",
  "Secret Key*": "Secret Key*",
  "Security": "Security",
  "See all AI Systems": "See all AI Systems",
  "See all results": "See all results",
  "See assessed controls, lowest first": "See assessed controls, lowest first",
  "See details": "See details",
  "See less": "See less",
  "See {count} controls not yet assessed": "See {count} controls not yet assessed",
  "See {count} more": "See {count} more",
  "Seed": "Seed",
  "Select": "Select",
  "Select AWS Resource": "Select AWS Resource",
  "Select Azure Resource": "Select Azure Resource",
  "Select Category": "Select Category",
  "Select Control": "Select Control",
  "Select Control(s)": "Select Control(s)",
  "Select Date(s)": "Select Date(s)",
  "Select Evidence": "Select Evidence",
  "Select Framework(s)": "Select Framework(s)",
  "Select Integration Type": "Select Integration Type",
  "Select Method": "Select Method",
  "Select Metric": "Select Metric",
  "Select Policy": "Select Policy",
  "Select Risk": "Select Risk",
  "Select Risk(s)": "Select Risk(s)",
  "Select Risk(s)*": "Select Risk(s)*",
  "Select Tag by Name": "Select Tag by Name",
  "Select Threat(s)": "Select Threat(s)",
  "Select Threat(s)*": "Select Threat(s)*",
  "Select Threat*": "Select Threat*",
  "Select User": "Select User",
  "Select a Product Category and Role first": "Select a Product Category and Role first",
  "Select a Threat": "Select a Threat",
  "Select a User": "Select a User",
  "Select a field to see guidance on what to enter.": "Select a field to see guidance on what to enter.",
  "Select a risk above to pick threat vectors from the taxonomy, or leave blank to use suggested vectors.": "Select a risk above to pick threat vectors from the taxonomy, or leave blank to use suggested vectors.",
  "Select all": "Select all",
  "Select an external source to connect": "Select an external source to connect",
  "Select concept type:": "Select concept type:",
  "Select date": "Select date",
  "Select every user group that will interact with it.": "Select every user group that will interact with it.",
  "Select from an existing Test": "Select from an existing Test",
  "Select from existing": "Select from existing",
  "Select if the AI use case is, or may be, prohibited under Article 5 of the EU AI Act. This keeps the Article 5 obligation in scope and the AI System requires further review before it can continue. (Based on QH-14)": "Select if the AI use case is, or may be, prohibited under Article 5 of the EU AI Act. This keeps the Article 5 obligation in scope and the AI System requires further review before it can continue. (Based on QH-14)",
  "Select if you intend to supply the AI system or AI element for use or integration in a third-party high-risk AI system, and it is NOT released under free and open-source licences only. (Based on QH-45, QH-46)": "Select if you intend to supply the AI system or AI element for use or integration in a third-party high-risk AI system, and it is NOT released under free and open-source licences only. (Based on QH-45, QH-46)",
  "Select if, when placing an AI system on the market or putting it into service in the EU, you do NOT clearly prohibit its change into a high-risk AI system. (Based on QH-47)": "Select if, when placing an AI system on the market or putting it into service in the EU, you do NOT clearly prohibit its change into a high-risk AI system. (Based on QH-47)",
  "Select tag(s) and add to the": "Select tag(s) and add to the",
  "Select the regions where the people affected by this system's outputs are located, not where your company is headquartered or where the servers run. For internal systems, that means the regions where the employees or business units using it or affected by it sit.": "Select the regions where the people affected by this system's outputs are located, not where your company is headquartered or where the servers run. For internal systems, that means the regions where the employees or business units using it or affected by it sit.",
  "Select time": "Select time",
  "Select where the system stands in the AI life cycle, from design through deployment, operation, and eventually retirement.": "Select where the system stands in the AI life cycle, from design through deployment, operation, and eventually retirement.",
  "Select which {unit} to include in this Job.": "Select which {unit} to include in this Job.",
  "Select {name}": "Select {name}",
  "Send": "Send",
  "Send notifications directly to Slack channels or direct messages.": "Send notifications directly to Slack channels or direct messages.",
  "Send password reset email to {name}?": "Send password reset email to {name}?",
  "Send reset email": "Send reset email",
  "Send to Scout": "Send to Scout",
  "Server URL*": "Server URL*",
  "Service is down": "Service is down",
  "Service is unstable at the moment, wait some minutes or, if the problem persists": "Service is unstable at the moment, wait some minutes or, if the problem persists",
  "Session": "Session",
  "Set a loss amount you care about — we compute the chance of exceeding it.": "Set a loss amount you care about — we compute the chance of exceeding it.",
  "Set the AI lifecycle stage in the AI System settings": "Set the AI lifecycle stage in the AI System settings",
  "Set up authenticator app": "Set up authenticator app",
  "Set up each environment you read agent details from in the Power Platform admin center:": "Set up each environment you read agent details from in the Power Platform admin center:",
  "Set up your organization's required and optional taxonomies and tags here.": "Set up your organization's required and optional taxonomies and tags here.",
  "Settings": "Settings",
  "Setup URI": "Setup URI",
  "Setup URI copied": "Setup URI copied",
  "Setup key": "Setup key",
  "Setup key copied": "Setup key copied",
  "Severity": "Severity",
  "Severity is conditional on an event occurring and independent of event frequency.": "Severity is conditional on an event occurring and independent of event frequency.",
  "Severity p95": "Severity p95",
  "Severity p99": "Severity p99",
  "Severity preview": "Severity preview",
  "Share of {name}": "Share of {name}",
  "Shared": "Shared",
  "Show": "Show",
  "Show Everything": "Show Everything",
  "Show all scopes": "Show all scopes",
  "Show archived": "Show archived",
  "Show conversations": "Show conversations",
  "Show details": "Show details",
  "Show details for {name}": "Show details for {name}",
  "Show diagram": "Show diagram",
  "Show filters": "Show filters",
  "Show less": "Show less",
  "Show source": "Show source",
  "Show the {count} Ready to Sign Off": "Show the {count} Ready to Sign Off",
  "Show the {count} requirement ready to sign off? | Show the {count} requirements ready to sign off?": "Show the {count} requirement ready to sign off? | Show the {count} requirements ready to sign off?",
  "Showing {shown} of {total}": "Showing {shown} of {total}",
  "Showing {shown} of {total} controls": "Showing {shown} of {total} controls",
  "Showing {shown} of {total} controls (of {grand} total)": "Showing {shown} of {total} controls (of {grand} total)",
  "Showing {shown} of {total} requirements": "Showing {shown} of {total} requirements",
  "Showing {shown} of {total} requirements (of {grand} total)": "Showing {shown} of {total} requirements (of {grand} total)",
  "Simple Moving Average — smooths short-term fluctuations": "Simple Moving Average — smooths short-term fluctuations",
  "Simulation Results": "Simulation Results",
  "Simulation Settings": "Simulation Settings",
  "Size": "Size",
  "Skipped": "Skipped",
  "Slack": "Slack",
  "Software that uses machine learning, logic, or knowledge-based approaches to generate outputs such as predictions, recommendations, decisions, or content that can influence environments it interacts with.": "Software that uses machine learning, logic, or knowledge-based approaches to generate outputs such as predictions, recommendations, decisions, or content that can influence environments it interacts with.",
  "Some sources or connectors of this question can no longer be used. Check them and send it again.": "Some sources or connectors of this question can no longer be used. Check them and send it again.",
  "Source": "Source",
  "Source & Connectors": "Source & Connectors",
  "Source Details": "Source Details",
  "Source Name*": "Source Name*",
  "Source Template": "Source Template",
  "Source list is empty.": "Source list is empty.",
  "Source*": "Source*",
  "Sources": "Sources",
  "Sources and connectors sent with this message": "Sources and connectors sent with this message",
  "Sources are shared. An AI System's owners and editors set them up once, with credentials, in the system's Settings, and everyone with access to that system works with the same sources. Modulos reads live data from them to run Metric Tests and Agent Tests, and Scout can inspect them.": "Sources are shared. An AI System's owners and editors set them up once, with credentials, in the system's Settings, and everyone with access to that system works with the same sources. Modulos reads live data from them to run Metric Tests and Agent Tests, and Scout can inspect them.",
  "Sources list is empty": "Sources list is empty",
  "Specific Risk": "Specific Risk",
  "Split AI System limits evenly to keep allocations balanced across all AI Systems.": "Split AI System limits evenly to keep allocations balanced across all AI Systems.",
  "Stacked": "Stacked",
  "Standard deviation": "Standard deviation",
  "Standard error": "Standard error",
  "Start Now": "Start Now",
  "Start by adding a Framework.": "Start by adding a Framework.",
  "Start by creating a New AI System.": "Start by creating a New AI System.",
  "Start chat": "Start chat",
  "Started": "Started",
  "Started At": "Started At",
  "Starting investigation...": "Starting investigation...",
  "Starts": "Starts",
  "State": "State",
  "Status": "Status",
  "Status Change Request assigned to you.": "Status Change Request assigned to you.",
  "Status Change*": "Status Change*",
  "Status Page": "Status Page",
  "Status changed": "Status changed",
  "Status*": "Status*",
  "Steps": "Steps",
  "Stop": "Stop",
  "Stop Job": "Stop Job",
  "Stop “{name}”?": "Stop “{name}”?",
  "Street": "Street",
  "String": "String",
  "Submit": "Submit",
  "Submit an AI System for review in the AI Registry to see its Risks here.": "Submit an AI System for review in the AI Registry to see its Risks here.",
  "Submit for review": "Submit for review",
  "Submit for review again": "Submit for review again",
  "Submit this status update for review.": "Submit this status update for review.",
  "Submitted": "Submitted",
  "Subprocessor": "Subprocessor",
  "Subscription IDs (Optional)": "Subscription IDs (Optional)",
  "Subscription*": "Subscription*",
  "Succeeded": "Succeeded",
  "Successfully created {count} evidence.": "Successfully created {count} evidence.",
  "Suggestions could not be generated": "Suggestions could not be generated",
  "Sum of all 'AI System Risk Limits' should match 'Total Organization Risk Appetite'.": "Sum of all 'AI System Risk Limits' should match 'Total Organization Risk Appetite'.",
  "Sum of all individual 'Risk Limits' from one Category should match 'AI System Category Risk Limit'.": "Sum of all individual 'Risk Limits' from one Category should match 'AI System Category Risk Limit'.",
  "Summary": "Summary",
  "Super Admin": "Super Admin",
  "Supervisor Reasoning": "Supervisor Reasoning",
  "Supplier": "Supplier",
  "Support": "Support",
  "Supported formats:": "Supported formats:",
  "System Information": "System Information",
  "Systemic Risk": "Systemic Risk",
  "Systems in review, approved or rejected count. Drafts do not count.": "Systems in review, approved or rejected count. Drafts do not count.",
  "TAGS": "TAGS",
  "THINKING": "THINKING",
  "Tag(s)": "Tag(s)",
  "Tags": "Tags",
  "Tangible": "Tangible",
  "Target Go-Live Date": "Target Go-Live Date",
  "Taxonomy list is empty": "Taxonomy list is empty",
  "Telefónica Partner": "Telefónica Partner",
  "Tell Scout what to change": "Tell Scout what to change",
  "Tell Scout what to change…": "Tell Scout what to change…",
  "Templates Catalog": "Templates Catalog",
  "Templates successfully uploaded": "Templates successfully uploaded",
  "Tenant ID is required": "Tenant ID is required",
  "Tenant ID*": "Tenant ID*",
  "Terms and Conditions": "Terms and Conditions",
  "Terms of Service URL": "Terms of Service URL",
  "Test": "Test",
  "Test Execution Log": "Test Execution Log",
  "Test Name*": "Test Name*",
  "Test Now": "Test Now",
  "Test Objective": "Test Objective",
  "Test Results History": "Test Results History",
  "Test exception": "Test exception",
  "Test executed successfully": "Test executed successfully",
  "Test successfully {status}.": "Test successfully {status}.",
  "Test {name} assigned to {user}": "Test {name} assigned to {user}",
  "Test {name} was updated": "Test {name} was updated",
  "Test {testName} successfully associated with Control {controlCode}": "Test {testName} successfully associated with Control {controlCode}",
  "Test {testName} successfully removed from Control {controlCode}": "Test {testName} successfully removed from Control {controlCode}",
  "Testing": "Testing",
  "Tests": "Tests",
  "Thank you for completing the questionnaire!": "Thank you for completing the questionnaire!",
  "Thanks": "Thanks",
  "That is a Connector.": "That is a Connector.",
  "That is a Source.": "That is a Source.",
  "The AI Agent is analysing your upload. Recommendations will appear automatically.": "The AI Agent is analysing your upload. Recommendations will appear automatically.",
  "The AI System returns to Pending and a reviewer decides again. Address the feedback first.": "The AI System returns to Pending and a reviewer decides again. Address the feedback first.",
  "The AI system falls under none of the prohibited, high-risk or transparency tiers. \"Minimal risk\" is the term used by the European Commission; the EU AI Act itself does not name this tier. No tier-specific obligations apply, but obligations that cover every AI system, such as AI literacy, still do.": "The AI system falls under none of the prohibited, high-risk or transparency tiers. \"Minimal risk\" is the term used by the European Commission; the EU AI Act itself does not name this tier. No tier-specific obligations apply, but obligations that cover every AI system, such as AI literacy, still do.",
  "The EU AI Act categorizes AI systems by their potential impact and risk level.": "The EU AI Act categorizes AI systems by their potential impact and risk level.",
  "The address you used isn't the same as the one in your invitation": "The address you used isn't the same as the one in your invitation",
  "The agent inspects all connected sources by default. Pick sources only to narrow the scope.": "The agent inspects all connected sources by default. Pick sources only to narrow the scope.",
  "The agent is working. The report appears here when the run finishes.": "The agent is working. The report appears here when the run finishes.",
  "The creator stays an owner during creation and can be removed in the settings afterwards.": "The creator stays an owner during creation and can be removed in the settings afterwards.",
  "The decision rule": "The decision rule",
  "The full Modulos Platform features are enabled for bigger resolution screens": "The full Modulos Platform features are enabled for bigger resolution screens",
  "The graph couldn't be loaded": "The graph couldn't be loaded",
  "The in-flight run is cancelled and queued runs are dropped. The Job stays scheduled - next run {date}.": "The in-flight run is cancelled and queued runs are dropped. The Job stays scheduled - next run {date}.",
  "The in-flight run is cancelled and queued runs are dropped. The Job stays scheduled for its next run.": "The in-flight run is cancelled and queued runs are dropped. The Job stays scheduled for its next run.",
  "The in-flight run is cancelled and queued runs are dropped. This Job has no schedule and only runs on demand.": "The in-flight run is cancelled and queued runs are dropped. This Job has no schedule and only runs on demand.",
  "The in-flight run is cancelled and queued runs are dropped. This Job runs only once, so it will not run again.": "The in-flight run is cancelled and queued runs are dropped. This Job runs only once, so it will not run again.",
  "The job can be run on demand": "The job can be run on demand",
  "The key has: {scopes}.": "The key has: {scopes}.",
  "The key lacks the {scope} scope. Scopes can't be changed, so create a new key with this scope and enter it again.": "The key lacks the {scope} scope. Scopes can't be changed, so create a new key with this scope and enter it again.",
  "The main language or languages in which the system interacts with users. This matters for user-facing notices, instructions for use, and testing.": "The main language or languages in which the system interacts with users. This matters for user-facing notices, instructions for use, and testing.",
  "The number of users that have been invited but have not logged in yet, excluding internal Modulos users.": "The number of users that have been invited but have not logged in yet, excluding internal Modulos users.",
  "The number of users that have logged in at least once to their accounts, excluding internal Modulos users.": "The number of users that have logged in at least once to their accounts, excluding internal Modulos users.",
  "The owner is accountable for this AI System in the registry: keeping its information current, answering review questions, and driving the compliance work that follows from registration. Pick the person answerable for the system's use in your organization, which is not necessarily whoever fills in this form.": "The owner is accountable for this AI System in the registry: keeping its information current, answering review questions, and driving the compliance work that follows from registration. Pick the person answerable for the system's use in your organization, which is not necessarily whoever fills in this form.",
  "The person contributing to the AI System execution (e.g. data scientist, ML engineer, data engineer, data analyst)": "The person contributing to the AI System execution (e.g. data scientist, ML engineer, data engineer, data analyst)",
  "The person responsible for the AI System execution and delivery (e.g. project manager, lead data scientist)": "The person responsible for the AI System execution and delivery (e.g. project manager, lead data scientist)",
  "The person with read-only access to the AI System (e.g. internal audit, external stakeholder)": "The person with read-only access to the AI System (e.g. internal audit, external stakeholder)",
  "The portfolio could not be loaded.": "The portfolio could not be loaded.",
  "The primary owner enables the Compliance API in claude.ai under Organization settings → API.": "The primary owner enables the Compliance API in claude.ai under Organization settings → API.",
  "The primary owner turns it on in claude.ai under Organization settings → API": "The primary owner turns it on in claude.ai under Organization settings → API",
  "The product does not fall under the EU AI Act definitions of AI System or General Purpose AI Model. May still be subject to other regulations.": "The product does not fall under the EU AI Act definitions of AI System or General Purpose AI Model. May still be subject to other regulations.",
  "The remaining controls are assessed on every run, even if they already have an agent assessment.": "The remaining controls are assessed on every run, even if they already have an agent assessment.",
  "The risk classification for this use case. High Risk systems trigger conformity assessments and ongoing monitoring; Annex III - Not High-Risk covers an Annex III use case assessed as not high-risk under the Article 6(3) derogation; Transparency covers chatbots and AI generated content; Minimal Risk records that none of these tiers applies.": "The risk classification for this use case. High Risk systems trigger conformity assessments and ongoing monitoring; Annex III - Not High-Risk covers an Annex III use case assessed as not high-risk under the Article 6(3) derogation; Transparency covers chatbots and AI generated content; Minimal Risk records that none of these tiers applies.",
  "The source \"{sourceName}\" has been disabled at the organization level. Please select a different source or contact your administrator to re-enable it.": "The source \"{sourceName}\" has been disabled at the organization level. Please select a different source or contact your administrator to re-enable it.",
  "The sources below are not enabled for your organization.": "The sources below are not enabled for your organization.",
  "The submitter will be notified. The AI System is approved for use.": "The submitter will be notified. The AI System is approved for use.",
  "The submitter will be notified. The record is kept for audit.": "The submitter will be notified. The record is kept for audit.",
  "The token displayed below can only be shown once. For your security, please copy and store it in a safe and secure location immediately. Failure to do so may result in the inability to retrieve or use the token in the future. Handle with care!": "The token displayed below can only be shown once. For your security, please copy and store it in a safe and secure location immediately. Failure to do so may result in the inability to retrieve or use the token in the future. Handle with care!",
  "The total amount of 'seats' the organization is allowed. Invited and active users count. Excluding internal Modulos users": "The total amount of 'seats' the organization is allowed. Invited and active users count. Excluding internal Modulos users.",
  "The total number of users allowed under the quota for this organization. Including invited users. Excluding internal Modulos users. Similar to 'seats taken'": "The total number of users allowed under the quota for this organization. Including invited users. Excluding internal Modulos users. Similar to 'seats taken'",
  "The total number of users associated with this organization.": "The total number of users associated with this organization.",
  "The two entered loss values are calibration anchors at p5 and p95, not samples.": "The two entered loss values are calibration anchors at p5 and p95, not samples.",
  "There are currently no available frameworks of type {type}.": "There are currently no available frameworks of type {type}.",
  "There are no AI System roles associated to this user.": "There are no AI System roles associated to this user.",
  "There are no controls for the selected filter(s).": "There are no controls for the selected filter(s).",
  "There are no templates published yet.": "There are no templates published yet.",
  "There is no requirements for the selected filter(s).": "There are no requirements for the selected filter(s).",
  "There was a problem": "There was a problem",
  "These AI Systems were already being created, in another tab or before the page reloaded. Check My Submissions for what was created.": "These AI Systems were already being created, in another tab or before the page reloaded. Check My Submissions for what was created.",
  "These Compliance Access Keys can delete chats, files and projects: {keys}. Modulos never deletes, so its key needs read scopes only.": "These Compliance Access Keys can delete chats, files and projects: {keys}. Modulos never deletes, so its key needs read scopes only.",
  "These documents explain your rights and obligations regarding our service": "These documents explain your rights and obligations regarding our service",
  "These settings will apply to your whole organization.": "These settings will apply to your whole organization.",
  "This AI System has left onboarding. Send your question again.": "This AI System has left onboarding. Send your question again.",
  "This AI System is not part of the organization's risk appetite while it is Rejected. It receives a limit when it is submitted for approval.": "This AI System is not part of the organization's risk appetite while it is Rejected. It receives a limit when it is submitted for approval.",
  "This Compliance Access Key can delete chats, files and projects: {keys}. Modulos never deletes, so its key needs read scopes only.": "This Compliance Access Key can delete chats, files and projects: {keys}. Modulos never deletes, so its key needs read scopes only.",
  "This Job has run before. A new run executes everything the Job includes again, and the latest results will be the ones from this run.": "This Job has run before. A new run executes everything the Job includes again, and the latest results will be the ones from this run.",
  "This action can’t be undone.": "This action can’t be undone.",
  "This action is irreversible and may impact the AI System status.": "This action is irreversible and may impact the AI System status.",
  "This action is irreversible. Please make sure to review all details before proceeding.": "This action is irreversible. Please make sure to review all details before proceeding.",
  "This asset is under review by": "This asset is under review by",
  "This category has no risks": "This category has no risks",
  "This category is already archived": "This category is already archived",
  "This chat is Global.": "This chat is Global.",
  "This chat stays with {name}.": "This chat stays with {name}.",
  "This connector is not enabled. Please contact your administrator to enable it for your organization.": "This connector is not enabled. Please contact your administrator to enable it for your organization.",
  "This conversation is no longer available.": "This conversation is no longer available.",
  "This conversation is too long for Scout. Start a new chat.": "This conversation is too long for Scout. Start a new chat.",
  "This could not be checked. Check again later.": "This could not be checked. Check again later.",
  "This diagram could not be drawn.": "This diagram could not be drawn.",
  "This document could not be processed.": "This document could not be processed.",
  "This entry drives the legal classification of the system, so accuracy here saves work everywhere else.": "This entry drives the legal classification of the system, so accuracy here saves work everywhere else.",
  "This field is required": "This field is required",
  "This file could not be read. It may be damaged, encrypted or empty. If it opens correctly on your computer, contact support.": "This file could not be read. It may be damaged, encrypted or empty. If it opens correctly on your computer, contact support.",
  "This file could not be read: the file is missing": "This file could not be read: the file is missing",
  "This file could not be read: the file type is not supported": "This file could not be read: the file type is not supported",
  "This folder is empty": "This folder is empty",
  "This graph is too large to show at once": "This graph is too large to show at once",
  "This is about the engineering life of the system itself, not your adoption status: a purchased product you are still evaluating is already in operation as a product, while your deployment of it may still be in testing. Select the stage that describes your deployment, and update it as the system moves; it determines which controls and evidence apply.": "This is about the engineering life of the system itself, not your adoption status: a purchased product you are still evaluating is already in operation as a product, while your deployment of it may still be in testing. Select the stage that describes your deployment, and update it as the system moves; it determines which controls and evidence apply.",
  "This is not a Compliance Access Key. Create one in claude.ai under Organization settings → API.": "This is not a Compliance Access Key. Create one in claude.ai under Organization settings → API.",
  "This is not an Analytics API key. Create one in claude.ai under Organization settings → API.": "This is not an Analytics API key. Create one in claude.ai under Organization settings → API.",
  "This is the maximum total risk exposure your organization is willing to accept across all AI systems": "This is the maximum total risk exposure your organization is willing to accept across all AI systems",
  "This item no longer exists": "This item no longer exists",
  "This number anchors risk management for the system: a potential loss of EUR 1M means something entirely different for a system expected to deliver EUR 100k a year than for one delivering EUR 100M. An honest rough estimate beats a blank field.": "This number anchors risk management for the system: a potential loss of EUR 1M means something entirely different for a system expected to deliver EUR 100k a year than for one delivering EUR 100M. An honest rough estimate beats a blank field.",
  "This page": "This page",
  "This proposal is closed. Ask Scout to propose AI Systems again.": "This proposal is closed. Ask Scout to propose AI Systems again.",
  "This questionnaire is designed to assist you in determining your obligations with respect to the": "This questionnaire is designed to help you determine your obligations under the",
  "This re-enables their login and restores platform access.": "This re-enables their login and restores platform access.",
  "This risk is already archived": "This risk is already archived",
  "This run produced no report.": "This run produced no report.",
  "This run used a {family} frequency distribution. This form can only edit Poisson frequencies — please re-enter the expected events per year to re-run.": "This run used a {family} frequency distribution. This form can only edit Poisson frequencies — please re-enter the expected events per year to re-run.",
  "This run used a {family} severity distribution. The 3-point form can only edit lognormal severities — please re-enter credible low/high to re-run.": "This run used a {family} severity distribution. The 3-point form can only edit lognormal severities — please re-enter credible low/high to re-run.",
  "This source is not enabled. Please contact your administrator to enable it for your organization.": "This source is not enabled. Please contact your administrator to enable it for your organization.",
  "This test is currently disabled, you must enable it in order to run the test.": "This test is currently disabled, you must enable it in order to run the test.",
  "This threat is already archived": "This threat is already archived",
  "This user owns the policies listed below. Please reassign ownership in the Policy Center before proceeding.": "This user owns the policies listed below. Please reassign ownership in the Policy Center before proceeding.",
  "This user owns {count} policies that must be reassigned before deactivation": "This user owns {count} policies that must be reassigned before deactivation",
  "This user owns {count} policies that must be reassigned before role removal": "This user owns {count} policies that must be reassigned before role removal",
  "This week": "This week",
  "This will affect existing and new AI Systems in your organization. Are you sure you want to proceed?": "This will affect existing and new AI Systems in your organization. Are you sure you want to proceed?",
  "This will cancel the invitation link.": "This will cancel the invitation link.",
  "This will delete the current risk and its threat definitions. This action cannot be undone. Do you want to continue?": "This will delete the current risk and its threat definitions. This action cannot be undone. Do you want to continue?",
  "This will email {name} a link to reset their password.": "This will email {name} a link to reset their password.",
  "Threat": "Threat",
  "Threat Description": "Threat Description",
  "Threat Name": "Threat Name",
  "Threat Name*": "Threat Name*",
  "Threat Vector": "Threat Vector",
  "Threat Vector Taxonomy": "Threat Vector Taxonomy",
  "Threat Vectors": "Threat Vectors",
  "Threat Vectors list is empty": "Threat Vectors list is empty",
  "Threat Vectors*": "Threat Vectors*",
  "Threat added successfully": "Threat added successfully",
  "Threat archived successfully": "Threat archived successfully",
  "Threat deleted successfully": "Threat deleted successfully",
  "Threat name is required": "Threat name is required",
  "Threat not found": "Threat not found",
  "Threat removed successfully": "Threat removed successfully",
  "Threat {name} created successfully": "Threat {name} created successfully",
  "Threat {name} updated successfully": "Threat {name} updated successfully",
  "Threats": "Threats",
  "Threats added successfully": "Threats added successfully",
  "Threats list is empty": "Threats list is empty",
  "Threshold": "Threshold",
  "Throttled": "Throttled",
  "Time": "Time",
  "Time*": "Time*",
  "Timeframe": "Timeframe",
  "Timestamp": "Timestamp",
  "To add new frameworks, update outdated ones first.": "To add new frameworks, update outdated ones first.",
  "To add new frameworks, update outdated ones in AI System Settings first.": "To add new frameworks, update outdated ones in AI System Settings first.",
  "Today": "Today",
  "Token Name*": "Token Name*",
  "Token created successfully": "Token created successfully",
  "Token deleted successfully": "Token deleted successfully",
  "Token:": "Token:",
  "Tokens": "Tokens",
  "Tokens list is empty": "Tokens list is empty",
  "Top 3 Highest Risk Value AI Systems": "Top 3 Highest Risk Value AI Systems",
  "Top 3 Highest Risk per Category (across AI Systems)": "Top 3 Highest Risk per Category (across AI Systems)",
  "Top 3 Highest Risks": "Top 3 Highest Risks",
  "Top Quantified Risks (by economic impact)": "Top Quantified Risks (by economic impact)",
  "Total": "Total",
  "Total Economic Value": "Total Economic Value",
  "Total Organization Risk Appetite": "Total Organization Risk Appetite",
  "Total Organization Risk Exposure": "Total Organization Risk Exposure",
  "Total Risk Appetite Configuration": "Total Risk Appetite Configuration",
  "Total Risk Value": "Total Risk Value",
  "Total Users": "Total Users",
  "Total tokens": "Total tokens",
  "Trace": "Trace",
  "Tracing {name}: no linked items.": "Tracing {name}: no linked items.",
  "Tracing {name}: {items}. Other items are dimmed.": "Tracing {name}: {items}. Other items are dimmed.",
  "Track monthly AI cost against this quota.": "Track monthly AI cost against this quota.",
  "Transparency": "Transparency",
  "Trials": "Trials",
  "Triggered by": "Triggered by",
  "Trusted by": "Trusted by",
  "Try changing your filter.": "Try changing your filter.",
  "Try changing your filters.": "Try changing your filters.",
  "Try changing your search.": "Try changing your search.",
  "Try selecting a VM, Storage Account, Database, or other monitored resource.": "Try selecting a VM, Storage Account, Database, or other monitored resource.",
  "Try selecting an EC2 instance, RDS database, Lambda function, or other monitored resource.": "Try selecting an EC2 instance, RDS database, Lambda function, or other monitored resource.",
  "Turn Off Tests": "Turn Off Tests",
  "Turn Off Threat Vectors": "Turn Off Threat Vectors",
  "Turn on": "Turn on",
  "Turning a connector type off here disconnects it for every user in the organization.": "Turning a connector type off here disconnects it for every user in the organization.",
  "Turning a source type off here disables it in every AI System and stops the tests that depend on it.": "Turning a source type off here disables it in every AI System and stops the tests that depend on it.",
  "Two-factor authentication": "Two-factor authentication",
  "Two-factor authentication enabled": "Two-factor authentication enabled",
  "Two-factor authentication removed": "Two-factor authentication removed",
  "Two-factor setup started": "Two-factor setup started",
  "Type": "Type",
  "Type the description": "Type the description",
  "Type:": "Type:",
  "URL is required": "URL is required",
  "Unarchive": "Unarchive",
  "Unarchive Policy": "Unarchive Policy",
  "Unarchive Policy Template": "Unarchive Policy Template",
  "Unassigned": "Unassigned",
  "Ungrouped": "Ungrouped",
  "Unit:": "Unit:",
  "Unknown": "Unknown",
  "Unlock": "Unlock",
  "Unlock User": "Unlock User",
  "Unlock {name}?": "Unlock {name}?",
  "Unpublished": "Unpublished",
  "Unquantified": "Unquantified",
  "Unreachable": "Unreachable",
  "Unread": "Unread",
  "Unscheduled": "Unscheduled",
  "Unselected files will be permanently removed from the platform.": "Unselected files will be permanently removed from the platform.",
  "Untitled AI System": "Untitled AI System",
  "Untitled conversation": "Untitled conversation",
  "Update Frameworks": "Update Frameworks",
  "Update Tag(s)": "Update Tag(s)",
  "Update Tag(s) for": "Update Tag(s) for",
  "Update needed": "Update needed",
  "Updated": "Updated",
  "Updated By": "Updated By",
  "Updated today": "Updated today",
  "Upload New Evidence": "Upload New Evidence",
  "Upload PDF": "Upload PDF",
  "Upload Template": "Upload Template",
  "Upload evidence documents for this system. You can also do this later in the Evidence Manager.": "Upload evidence documents for this system. You can also do this later in the Evidence Manager.",
  "Upload or attach relevant evidence here": "Upload or attach relevant evidence here",
  "Upload the files to enable the Evidence creation on the related tab.": "Upload the files to enable the Evidence creation on the related tab.",
  "Uploaded By": "Uploaded By",
  "Uploaded at": "Uploaded at",
  "Uploaded by": "Uploaded by",
  "Usage": "Usage",
  "Usage by feature": "Usage by feature",
  "Usage by model": "Usage by model",
  "Usage by organization": "Usage by organization",
  "Usage over time": "Usage over time",
  "Usage recorded without an organization. It counts toward the totals above, but no organization can be opened for it.": "Usage recorded without an organization. It counts toward the totals above, but no organization can be opened for it.",
  "Use & Documents": "Use & Documents",
  "Use Case": "Use Case",
  "Use a Compliance Access Key (starts with sk-ant-api01-) from claude.ai → Organization settings → API, not an Admin API key": "Use a Compliance Access Key (starts with sk-ant-api01-) from claude.ai → Organization settings → API, not an Admin API key",
  "Use an organization Admin API key (starts with sk-admin-) from Settings → Organization → Admin keys, not a project key": "Use an organization Admin API key (starts with sk-admin-) from Settings → Organization → Admin keys, not a project key",
  "Use an organization Admin API key (starts with sk-ant-admin01-) from Settings → Admin keys, not a regular API key": "Use an organization Admin API key (starts with sk-ant-admin01-) from Settings → Admin keys, not a regular API key",
  "Used by staff in a controlled context": "Used by staff in a controlled context",
  "User": "User",
  "User Access": "User Access",
  "User Guidance": "User Guidance",
  "User Management": "User Management",
  "User Profile": "User Profile",
  "User Settings": "User Settings",
  "User information for {name} has been updated": "User information for {name} has been updated",
  "User is deactivated": "User is deactivated",
  "User is not registered": "User is not registered",
  "User role(s) updated successfully": "User role(s) updated successfully",
  "User {name} is successfully {action}": "User {name} is successfully {action}",
  "User {name} unlocked": "User {name} unlocked",
  "User {name} was successfully invited": "User {name} was successfully invited",
  "Users": "Users",
  "Users Quota": "Users Quota",
  "Users Quota Count": "Users Quota Count",
  "Users and group members": "Users and group members",
  "Users list is empty": "Users list is empty",
  "Users previously added in the organisation level.": "Users previously added in the organisation level.",
  "Uses an AI system under your authority, except for personal non-professional activities. Includes organizations that use AI systems in their operations.": "Uses an AI system under your authority, except for personal non-professional activities. Includes organizations that use AI systems in their operations.",
  "Utilization": "Utilization",
  "VaR at {alpha}%": "VaR at {alpha}%",
  "Value": "Value",
  "Value is required": "Value is required",
  "Value must be greater than 0": "Value must be greater than 0",
  "Value must be greater than or equal to 0": "Value must be greater than or equal to 0",
  "Value must be less than or equal to 1": "Value must be less than or equal to 1",
  "Value must be less than or equal to 5": "Value must be less than or equal to 5",
  "Value(optional)": "Value (optional)",
  "Value*": "Value*",
  "Vendor Details": "Vendor Details",
  "Vendor Name*": "Vendor Name*",
  "Vendor created successfully": "Vendor created successfully",
  "Vendor deleted successfully": "Vendor deleted successfully",
  "Vendor updated successfully": "Vendor updated successfully",
  "Vendors": "Vendors",
  "Vendors list is empty": "Vendors list is empty",
  "Verification code": "Verification code",
  "Verify": "Verify",
  "Version": "Version",
  "Version History": "Version History",
  "Versions": "Versions",
  "View": "View",
  "View AI System": "View AI System",
  "View Draft": "View Draft",
  "View Published": "View Published",
  "View Run Report": "View Run Report",
  "View Threat Vector": "View Threat Vector",
  "View Usage": "View Usage",
  "View events": "View events",
  "View in My Submissions": "View in My Submissions",
  "View quantification": "View quantification",
  "View test": "View test",
  "View trace": "View trace",
  "Viewer": "Viewer",
  "Waiting for AI quota": "Waiting for AI quota",
  "Waiting to be processed": "Waiting to be processed",
  "Warehouse is required": "Warehouse is required",
  "Warehouse*": "Warehouse*",
  "We are ~95% confident the loss is at least this much.": "We are ~95% confident the loss is at least this much.",
  "We are ~95% confident the loss is no more than this.": "We are ~95% confident the loss is no more than this.",
  "We couldn't find that page": "We couldn't find that page",
  "We'd like to raise the limits on our plan.": "We'd like to raise the limits on our plan.",
  "Website": "Website",
  "Website URL": "Website URL",
  "Weekly": "Weekly",
  "Weekly on {weekday}": "Weekly on {weekday}",
  "Weighted Expected Value": "Weighted Expected Value",
  "Welcome": "Welcome",
  "What are the open risks?": "What are the open risks?",
  "What happens after I submit?": "What happens after I submit?",
  "What is the agent being asked? Be specific: a vague objective produces a vague verdict.": "What is the agent being asked? Be specific: a vague objective produces a vague verdict.",
  "What kind of test do you want to run?": "What kind of test do you want to run?",
  "What should my team pick up this week?": "What should my team pick up this week?",
  "What the agent investigates": "What the agent investigates",
  "What this Monte Carlo run assumes about the world:": "What this Monte Carlo run assumes about the world:",
  "What this key reads: activity, organizations, users, settings and plugins. Select read scopes only when you create it.": "What this key reads: activity, organizations, users, settings and plugins. Select read scopes only when you create it.",
  "What this key reads: seats, active users, usage and spend per product. Scope to select in claude.ai: read:analytics.": "What this key reads: seats, active users, usage and spend per product. Scope to select in claude.ai: read:analytics.",
  "What this source can read": "What this source can read",
  "What will this system do, who will use it, and what problem does it solve?": "What will this system do, who will use it, and what problem does it solve?",
  "When do you expect this system to be in productive use? A rough estimate is fine; it drives review scheduling and deadlines.": "When do you expect this system to be in productive use? A rough estimate is fine; it drives review scheduling and deadlines.",
  "Where is this system today in your organization? Select Already in use if people are working with it now, even if it never went through formal review; registering it accurately is what brings it under governance from this point forward.": "Where is this system today in your organization? Select Already in use if people are working with it now, even if it never went through formal review; registering it accurately is what brings it under governance from this point forward.",
  "Where it runs": "Where it runs",
  "Where will this AI System run?": "Where will this AI System run?",
  "Where will this system be used? EU, UK, or Global scope makes the optional EU AI Act assessment in the next step relevant.": "Where will this system be used? EU, UK, or Global scope makes the optional EU AI Act assessment in the next step relevant.",
  "Whether the regulated product is a typical AI System or a General Purpose AI Model. GPAI models carry additional obligations such as model documentation and training data summaries.": "Whether the regulated product is a typical AI System or a General Purpose AI Model. GPAI models carry additional obligations such as model documentation and training data summaries.",
  "Which AI Systems are stuck in registration?": "Which AI Systems are stuck in registration?",
  "Which controls still have no evidence?": "Which controls still have no evidence?",
  "Which frameworks will apply?": "Which frameworks will apply?",
  "Which high-risk AI Systems have no approved owner?": "Which high-risk AI Systems have no approved owner?",
  "Window": "Window",
  "Within limit": "Within limit",
  "Without threats": "Without threats",
  "Worst Case": "Worst Case",
  "Would you like to activate {name}?": "Would you like to activate {name}?",
  "Would you like to cancel the Status Change Request?": "Would you like to cancel the Status Change Request?",
  "Would you like to cancel the invitation to {name}?": "Would you like to cancel the invitation to {name}?",
  "Would you like to change the settings?": "Would you like to change the settings?",
  "Would you like to deactivate {name}?": "Would you like to deactivate {name}?",
  "Would you like to discard AI Agent recommendations?": "Would you like to discard AI Agent recommendations?",
  "Would you like to permanently delete AI System": "Would you like to permanently delete AI System",
  "Would you like to permanently delete the Vendor": "Would you like to permanently delete the Vendor?",
  "Would you like to permanently delete this Document?": "Would you like to permanently delete this Document?",
  "Would you like to permanently delete uploaded file(s) and abort the Evidence creation?": "Would you like to permanently delete uploaded file(s) and abort the Evidence creation?",
  "Would you like to permanently delete {name}?": "Would you like to permanently delete {name}?",
  "Would you like to permanently remove {source} from the sources?": "Would you like to permanently remove {source} from the sources?",
  "Would you like to re-take the questionnaire?": "Would you like to re-take the questionnaire?",
  "Would you like to remove the association with the Control": "Would you like to remove the association with the Control",
  "Would you like to resend the invitation to {name}?": "Would you like to resend the invitation to {name}?",
  "Would you like to reset the form?": "Would you like to reset the form?",
  "Would you like to run the AI Agent?": "Would you like to run the AI Agent?",
  "Would you like to update the framework(s) to the latest version?": "Would you like to update the framework(s) to the latest version?",
  "Would you like to upload this new template?": "Would you like to upload this new template?",
  "Write PASS / FAIL / ERROR conditions in plain language.": "Write PASS / FAIL / ERROR conditions in plain language.",
  "Write about your deployment, not the vendor's marketing text. Concrete beats polished. What the system is meant to achieve belongs in Intended Purpose; here, explain what it does.": "Write about your deployment, not the vendor's marketing text. Concrete beats polished. What the system is meant to achieve belongs in Intended Purpose; here, explain what it does.",
  "Wrong key type": "Wrong key type",
  "Yes": "Yes",
  "Yes, create": "Yes, create",
  "Yes, create {count}": "Yes, create {count}",
  "Yesterday": "Yesterday",
  "You": "You",
  "You are not allowed to delete the AI System. Contact your admin..": "You are not allowed to delete the AI System. Contact your admin.",
  "You are trying to use an email address that is not registered in the system": "You are trying to use an email address that is not registered in the system",
  "You are up to date": "You are up to date",
  "You asked: “{text}”": "You asked: “{text}”",
  "You can also check the": "You can also check the",
  "You can change the requirement status anytime.": "You can change the requirement status anytime.",
  "You can keep editing this draft and working with Scout.": "You can keep editing this draft and working with Scout.",
  "You can name several owners, and any active user of your organization qualifies. The creator stays an owner while the system is being created; ownership can be handed over in the settings afterwards.": "You can name several owners, and any active user of your organization qualifies. The creator stays an owner while the system is being created; ownership can be handed over in the settings afterwards.",
  "You didn't create any AI Systems.": "You didn't create any AI Systems.",
  "You didn't create the {count} AI Systems.": "You didn't create the {count} AI Systems.",
  "You didn't create {name}.": "You didn't create {name}.",
  "You do not have any controls available for association at the moment.": "You do not have any controls available for association at the moment.",
  "You do not have permission to quantify risks in this AI System.": "You do not have permission to quantify risks in this AI System.",
  "You don't have access to this graph": "You don't have access to this graph",
  "You don't have an organization": "You don't have an organization",
  "You don't have permission. Contact the admin.": "You don't have permission. Contact the admin.",
  "You don’t have any AI Systems yet.": "You don’t have any AI Systems yet.",
  "You don’t have any Control attached to this AI System.": "You don’t have any Control attached to this AI System.",
  "You don’t have any Framework attached to this AI System.": "You don’t have any Framework attached to this AI System.",
  "You don’t have any notifications.": "You don’t have any notifications.",
  "You have not submitted any AI Systems yet.": "You have not submitted any AI Systems yet.",
  "You have reached the available limit.": "You have reached the available limit.",
  "You have unsaved changes": "You have unsaved changes",
  "You have unsaved changes. Switching tabs will discard them.": "You have unsaved changes. Switching tabs will discard them.",
  "You have unselected files": "You have unselected files",
  "You have used all {limit} of your AI Systems.": "You have used all {limit} of your AI Systems.",
  "You have {pending} pending acknowledgements of {total} total policies.": "You have {pending} pending acknowledgements of {total} total policies.",
  "You need to have at least one source enabled in order to create tests, contact your admin to enable the necessary sources.": "You need to have at least one source enabled in order to create tests, contact your admin to enable the necessary sources.",
  "You successfully reassigned reviewer(s) for status change": "You successfully reassigned reviewer(s) for status change",
  "You successfully requested review(s) for status change": "You successfully requested review(s) for status change",
  "You will lose all the data you have entered.": "You will lose all the data you have entered.",
  "You {decision} the status change": "You {decision} the status change",
  "You'll receive an email shortly with a link to verify your email and finish setting up your account.": "You'll receive an email shortly with a link to verify your email and finish setting up your account.",
  "You're on {page}.": "You're on {page}.",
  "You're over the AI Systems limit, so this draft can't be submitted as a new AI System.": "You're over the AI Systems limit, so this draft can't be submitted as a new AI System.",
  "Your GPAIM is supplied under terms other than free and open-source software licenses. Full GPAIM provider obligations apply.": "Your GPAIM is supplied under terms other than free and open-source software licenses. Full GPAIM provider obligations apply.",
  "Your account is being prepared": "Your account is being prepared",
  "Your account is protected with an authenticator app.": "Your account is protected with an authenticator app.",
  "Your account will no longer require codes from your authenticator app.": "Your account will no longer require codes from your authenticator app.",
  "Your chats show up here, newest first, each labelled with what it is about.": "Your chats show up here, newest first, each labelled with what it is about.",
  "Your current view hides it. Showing it turns on the Requirements layer and clears your filters. | Your current view hides some of them. Showing them turns on the Requirements layer and clears your filters.": "Your current view hides it. Showing it turns on the Requirements layer and clears your filters. | Your current view hides some of them. Showing them turns on the Requirements layer and clears your filters.",
  "Your identity provider has not yet verified your email address. Please verify it and try again.": "Your identity provider has not yet verified your email address. Please verify it and try again.",
  "Your journey to": "Your journey to",
  "Your organization does not have a defined role under the EU AI Act for this AI system.": "Your organization does not have a defined role under the EU AI Act for this AI system.",
  "Your organization has reached its licensed number of active users. Please contact your organization administrator.": "Your organization has reached its licensed number of active users. Please contact your organization administrator.",
  "Your organization has used up its AI quota.": "Your organization has used up its AI quota.",
  "Your organization is established outside the EU. If placing AI systems on the EU market, you may need an Authorised Representative.": "Your organization is established outside the EU. If placing AI systems on the EU market, you may need an Authorised Representative.",
  "Your organization is legally established within the European Union or European Economic Area.": "Your organization is legally established within the European Union or European Economic Area.",
  "Your organization is responsible for having a legal basis, for example approval by your data protection officer.": "Your organization is responsible for having a legal basis, for example approval by your data protection officer.",
  "Your organization reached its AI usage limit. This document will be processed automatically when more is available.": "Your organization reached its AI usage limit. This document will be processed automatically when more is available.",
  "Your position in the AI value chain: a Provider develops the system, a Deployer uses it in production, an Importer or Distributor places it on the market. You may hold more than one role.": "Your position in the AI value chain: a Provider develops the system, a Deployer uses it in production, an Importer or Distributor places it on the market. You may hold more than one role.",
  "Your unsaved changes will be lost if you proceed.": "Your unsaved changes will be lost if you proceed.",
  "Zoom": "Zoom",
  "Zoom in": "Zoom in",
  "Zoom out": "Zoom out",
  "a day": "a day",
  "a few seconds": "a few seconds",
  "a minute": "a minute",
  "a month": "a month",
  "a year": "a year",
  "activated": "activated",
  "an hour": "an hour",
  "and": "and",
  "antithetic": "antithetic",
  "antithetic + stratified": "antithetic + stratified",
  "as of {date}": "as of {date}",
  "cancelled": "cancelled",
  "chance the annual loss exceeds {amount}": "chance the annual loss exceeds {amount}",
  "completed": "completed",
  "contact": "contact",
  "contact us": "contact us",
  "controls": "controls",
  "could not be processed": "could not be processed",
  "days": "{n} days",
  "days_unit": "days",
  "disabled": "disabled",
  "e.g. 0.5": "e.g. 0.5",
  "e.g. 5,000,000": "e.g. 5,000,000",
  "e.g. 50,000": "e.g. 50,000",
  "e.g. Customer Support Chatbot": "e.g. Customer Support Chatbot",
  "enabled": "enabled",
  "fifth": "fifth",
  "first": "first",
  "for further information": "for further information",
  "for support": "for support",
  "fourth": "fourth",
  "frozen": "frozen",
  "hours": "{n} hours",
  "in %s": "in {0}",
  "inactive": "inactive",
  "integration.aws.instructions": "**Prerequisites:**\nAWS Resource Explorer must be enabled with at least one index configured. The connection test will fail without it.\n\n1. **Enable AWS Resource Explorer** (Required)\n   - Go to [AWS Resource Explorer](https://console.aws.amazon.com/resource-explorer/) in your AWS Console\n   - Click **\"Turn on Resource Explorer\"**\n   - Create an **Aggregator index** in your primary region\n   - Wait 5-10 minutes for indexing to complete\n   - [View Resource Explorer Setup Guide](https://docs.aws.amazon.com/resource-explorer/latest/userguide/getting-started.html) →\n\n2. **Create an IAM User**\n   In AWS Console, go to IAM → Users → Create user\n\n3. **Attach policies**\n   Navigate to **Permissions** → **Add permissions**\n   - Attach the AWS managed policy **ReadOnlyAccess**\n   - Ensure the user has **resource-explorer-2:ListIndexes** permission\n\n4. **Create access keys**\n   Go to **Security credentials** → **Create access key**\n   Select **Application running outside AWS**\n   Copy the **Access Key ID** and **Secret Access Key**\n\n5. **Enter credentials**\n   Paste Access Key ID, Secret Access Key, and AWS region in the respective fields\n\n**Note:** The IAM user will have read-only access to query AWS resources and CloudWatch metrics. Create one source per region.\n[View AWS IAM documentation](https://docs.aws.amazon.com/IAM/latest/UserGuide/id_users_create.html) →",
  "integration.aws.responsibility": "AWS infrastructure access",
  "integration.azure.instructions": "1. **Create a Service Principal**\n   In Azure Portal, go to Azure Active Directory → App registrations\n\n2. **Get the credentials**\n   - Tenant ID: Found in Azure AD overview\n   - Client ID: Application (client) ID from the app registration\n   - Client Secret: Create in Certificates & secrets\n\n3. **Grant Reader role**\n   Navigate to **Subscriptions → Access control (IAM) → Add role assignment**\n   Assign **Reader** role to the Service Principal\n\n4. **Enter credentials**\n   Paste Tenant ID, Client ID, and Client Secret in the respective fields\n\n5. **Optional: let Scout see Foundry agents**\n   Create a custom role with the single data action `Microsoft.CognitiveServices/accounts/AIServices/agents/read` and assign it to the same app on the subscriptions\n   Microsoft documents this permission as also allowing reads of agent threads and messages, which is conversation content\n\n6. **Optional: Scout's Azure cost report**\n   Uses the Reader role from step 3. If you grant a narrower custom role instead, also assign the built-in Cost Management Reader role to the same app\n\n**Note:** The Service Principal will have read-only access to query Azure resources.\n[View Azure Service Principal documentation](https://learn.microsoft.com/en-us/azure/active-directory/develop/howto-create-service-principal-portal) →",
  "integration.azure.responsibility": "Azure infrastructure access",
  "integration.claude_console.instructions": "1. **Open the Claude Console**\n   Sign in as an organization admin at platform.claude.com\n\n2. **Create an Admin API key**\n   Go to **Settings → Admin keys** and create a key (starts with sk-ant-admin01-)\n\n3. **Copy the key**\n\n4. **Enter credentials**\n   Paste the Admin API key into the Admin API Key field\n\n**Note:** This source covers Claude Code usage on the Claude API only. Usage via Amazon Bedrock, Google Cloud, Microsoft Foundry, and claude.ai Enterprise/Team seats is not included. Metrics appear only for Claude Code used with this organization's API keys. View detailed documentation →",
  "integration.claude_console.responsibility": "Claude Code usage & governance evidence",
  "integration.copilot_studio.instructions": "1. **Register a single-tenant app in Microsoft Entra**\n   In the Entra admin center, go to App registrations and create a new registration. No API permissions or admin consent are needed\n\n2. **Create a client secret**\n   Navigate to **Certificates & secrets** and generate a new client secret\n\n3. **Add the Dataverse application user**\n   In the Power Platform admin center, add the app registration as an application user in each environment you want agent details from. Assign only a custom security role with Organization-level **Read** on **Agent** (`bot`) and **Agent component** (`botcomponent`), and no create, write, delete or append rights\n\n4. **Enter the connection details**\n   Paste the Tenant ID, Client ID and Client Secret in the respective fields.\n\n5. **Choose the whole tenant or a single environment**\n   For the whole tenant, assign the **AI Reader** role to the app registration in Entra, leave the Dataverse environment URL empty and select **Discover environments** to pick the environments. For a single environment, open **Manage > Environments** in the Power Platform admin center, copy its Environment URL and paste it into the Dataverse environment URL field. For a tenant, save, reopen the source and select **Check environments** to see which ones are ready\n\n**Note:** The application user will have read-only access to query Copilot Studio agents via Dataverse.\n[View Power Platform application user documentation](https://learn.microsoft.com/en-us/power-platform/admin/manage-application-users) →\n[Setup guide](https://docs.modulos.ai/platform/integrations/copilot-studio) →",
  "integration.copilot_studio.responsibility": "Copilot Studio agent inventory",
  "integration.datadog.instructions": "1. **Access your Datadog account**\n   Log in to Datadog as Administrator\n\n2.Copy URL of the Datadog instance\n\n3. **Create an API key**\n\n4. **Create an Application Key.**\n\nView detailed documentation →",
  "integration.datadog.responsability": "Cloud Monitoring",
  "integration.github.instructions": "1. **Access your GitHub repository**\n   Ensure you have read access\n\n2. **For private repositories**\n   Create a Personal Access Token\n\n3. **Generate token with repo scope**\n   Navigate to **Settings → Developer settings → Personal access tokens**\n\n4. **Copy the token**\n   Paste it in the **Personal Access Token** field\n\n**Note:** Public repositories don't require a token.\n[View GitHub token documentation](https://docs.github.com/en/authentication/keeping-your-account-and-data-secure/managing-your-personal-access-tokens) →",
  "integration.github.responsability": "Source code repository",
  "integration.langfuse.instructions": "1. **Access your Langfuse account**\n   Log in to Langfuse (cloud.langfuse.com or your self-hosted instance)\n\n2. **Navigate to project settings**\n   Go to **Project → Settings**\n\n3. **Create or use existing API keys**\n   - Copy your **Langfuse Public Key**\n   - Copy your **Langfuse Secret Key**\n\n4. **Enter credentials**\n   Paste the API URL, Public Key, and Secret Key in the respective fields\n   Optionally specify a Project ID to filter data\n\n**Metric format:** Use `{view}:{measure}:{aggregation}` (e.g., observations:latency:p95)\n[View Langfuse API documentation](https://langfuse.com/docs/api-and-data-platform/features/public-api) →",
  "integration.langfuse.responsibility": "LLM observability metrics",
  "integration.openai_platform.instructions": "1. **Open the OpenAI Platform**\n   Sign in as an Organization Owner at platform.openai.com\n\n2. **Create an Admin API key**\n   Go to **Settings → Organization → Admin keys** and create a new admin key (starts with sk-admin-); set an expiry\n\n3. **Copy the key**\n\n4. **Enter credentials**\n   Paste the Admin API key into the Admin API Key field\n\n**Note:** This source covers one OpenAI **API Platform organization** through an Admin API key: API usage and spend (including Codex used with the organization's API keys) and the organization's governance configuration. Usage and spend are attributed to the **owner of the API key** that made each request, which is the only attribution OpenAI provides — a shared key is attributed to its owner. It does **not** cover ChatGPT Enterprise / Business workspaces, Codex used with ChatGPT sign-in, the Compliance Logs Platform, or Global Admin Console tenant settings — those will be separate sources; SCIM directory data is not enumerated (only the organization's SCIM-managed flag is read). Audit-log metrics are only populated after audit logging is enabled in the OpenAI dashboard (Settings → Organization → Data controls) — **once enabled it cannot be disabled without contacting OpenAI support**; this source never changes that setting. Daily usage and cost figures are complete only after the UTC day closes; the current day is never reported. The source reads the key owner's `/v1/me` and retains only this organization's id, name, key-minting policy and SCIM-managed flag, plus whether the key owner belongs to a Global Admin Console tenant. View detailed documentation →",
  "integration.openai_platform.responsibility": "OpenAI API usage, spend & governance posture",
  "integration.prometheus.instructions": "1. **Access your Prometheus server**\n   Log in as an admin user\n\n2. **Create an API token**\n   Navigate to **Settings → API Tokens**\n\n3. **Generate read-only token**\n   Select **\"Read\"** permissions for metrics\n\n4. **Copy the token**\n   Paste it in the **API Key** field\n\n**Pro tip:** Use a service account token for better security and stability.\nView detailed documentation →",
  "integration.prometheus.responsability": "Metrics from Prometheus server",
  "integration.snowflake.instructions": "1. **Create a read-only role and user**\n   In Snowflake, grant a dedicated user a role with read-only (USAGE and SELECT) privileges\n\n2. **Generate a Programmatic Access Token**\n   Navigate to **Admin → Users & Roles → select the user → Programmatic access tokens**\n\n3. **Copy the token**\n   Paste it in the **Programmatic Access Token** field\n\n4. **Enter connection details**\n   Provide the account identifier (ORG-ACCOUNT format), the warehouse, and the database\n\n**Note:** The user will have read-only access to query Snowflake data.\n[View Snowflake PAT documentation](https://docs.snowflake.com/en/user-guide/programmatic-access-tokens) →",
  "integration.snowflake.responsability": "Data warehouse access",
  "integration.vijil_evaluate.instructions": "1. **Access the Vijil Console**\n   Log in to your Vijil Console\n\n2. **Create an API key**\n   Navigate to **Settings → API Keys** to get a client ID (vk_...) and a one-time client secret\n\n3. **Copy the client ID and client secret**\n\n4. **Enter credentials**\n   Paste the Vijil agent ID, client ID and client secret in the respective fields\n\n**Note:** View detailed documentation →",
  "integration.vijil_evaluate.responsibility": "Vijil Console API integration",
  "invited": "invited",
  "items": "items",
  "login.terms.modulos": "By continuing you agree to Modulos's {terms}, and {freemium}, and confirm to have read and understood our {privacy}.",
  "may take a few minutes": "may take a few minutes",
  "minutes": "{n} minutes",
  "months": "{n} months",
  "not indexed yet": "not indexed yet",
  "not processed while AI features were off": "not processed while AI features were off",
  "of {limit} ({utilization}%)": "of {limit} ({utilization}%)",
  "of {total}": "of {total}",
  "optional": "optional",
  "or": "or",
  "pending": "pending",
  "quantified {date}": "quantified {date}",
  "recommendations": "Recommendations",
  "requirements": "requirements",
  "review.statusChange": "{firstName} {lastName} requested status change from {oldStatus} to {newStatus}",
  "risks available": "risks available",
  "second": "second",
  "selected": "selected",
  "sso_enabled": "SSO Enabled",
  "standard MC": "standard MC",
  "starts here": "starts here",
  "still being processed": "still being processed",
  "stratified": "stratified",
  "third": "third",
  "this AI System": "this AI System",
  "to continue with your sign-up process": "to continue with your sign-up process",
  "to upload": "to upload",
  "total_active_users": "Total Active Users",
  "total_app_projects": "Total AI Systems",
  "total_org_projects": "Total Org AI Systems",
  "total_organizations": "Total Organizations",
  "unfrozen": "unfrozen",
  "unread notification": "unread notification",
  "unread notifications": "unread notifications",
  "uploaded file(s).": "uploaded file(s).",
  "waiting for AI quota": "waiting for AI quota",
  "website": "website",
  "years": "{n} years",
  "your Organization Administrator or the Modulos": "your Organization Administrator or the Modulos",
  "zł - Polish Złoty (PLN)": "zł - Polish Złoty (PLN)",
  "{amount} items": "{amount} items",
  "{amount} of total risk appetite": "{amount} of total risk appetite",
  "{amount} risks associated with this threat": "{amount} risks associated with this threat",
  "{amount} threats associated with this risk": "{amount} threats associated with this risk",
  "{completed}/{total} steps": "{completed}/{total} steps",
  "{count} active": "{count} active",
  "{count} control | {count} controls": "{count} control | {count} controls",
  "{count} controls": "{count} controls",
  "{count} conversations match": "{count} conversations match",
  "{count} evidence document was not used in this assessment | {count} evidence documents were not used in this assessment": "{count} evidence document was not used in this assessment | {count} evidence documents were not used in this assessment",
  "{count} failed": "{count} failed",
  "{count} file could not be processed and was skipped | {count} files could not be processed and were skipped": "{count} file could not be processed and was skipped | {count} files could not be processed and were skipped",
  "{count} file is waiting for AI quota and was skipped | {count} files are waiting for AI quota and were skipped": "{count} file is waiting for AI quota and was skipped | {count} files are waiting for AI quota and were skipped",
  "{count} left": "{count} left",
  "{count} match for “{query}”, outlined on the map. Enter opens the first. | {count} matches for “{query}”, outlined on the map. Enter opens the first.": "{count} match for “{query}”, outlined on the map. Enter opens the first. | {count} matches for “{query}”, outlined on the map. Enter opens the first.",
  "{count} match for “{query}”. Other items are dimmed. | {count} matches for “{query}”. Other items are dimmed.": "{count} match for “{query}”. Other items are dimmed. | {count} matches for “{query}”. Other items are dimmed.",
  "{count} nodes": "{count} nodes",
  "{count} not assessed": "{count} not assessed",
  "{count} other AI System | {count} other AI Systems": "{count} other AI System | {count} other AI Systems",
  "{count} over the limit": "{count} over the limit",
  "{count} pending": "{count} pending",
  "{count} placeholder remaining. Replace all placeholders to enable saving and approval. | {count} placeholders remaining. Replace all placeholders to enable saving and approval.": "{count} placeholder remaining. Replace all placeholders to enable saving and approval. | {count} placeholders remaining. Replace all placeholders to enable saving and approval.",
  "{count} requirement | {count} requirements": "{count} requirement | {count} requirements",
  "{count} result for “{query}” | {count} results for “{query}”": "{count} result for “{query}” | {count} results for “{query}”",
  "{count} risk has no threats yet. | {count} risks have no threats yet.": "{count} risk has no threats yet. | {count} risks have no threats yet.",
  "{count} risk | {count} risks": "{count} risk | {count} risks",
  "{count} selected": "{count} selected",
  "{count} shared controls": "{count} shared controls",
  "{count} test | {count} tests": "{count} test | {count} tests",
  "{count}/{total} acknowledged": "{count}/{total} acknowledged",
  "{done} of {total}": "{done} of {total}",
  "{done} of {total} controls executed": "{done} of {total} controls executed",
  "{done} of {total} executed": "{done} of {total} executed",
  "{done} of {total} fulfilled": "{done} of {total} fulfilled",
  "{done} of {total} passing": "{done} of {total} passing",
  "{fulfilled} requirements fulfilled across {frameworks} framework. | {fulfilled} requirements fulfilled across {frameworks} frameworks.": "{fulfilled} requirements fulfilled across {frameworks} framework. | {fulfilled} requirements fulfilled across {frameworks} frameworks.",
  "{input} input tokens · {output} output tokens": "{input} input tokens · {output} output tokens",
  "{min}-{max} tokens": "{min}-{max} tokens",
  "{name} created successfully": "{name} created successfully",
  "{name} created. Run queued. The report will appear in the runs list.": "{name} created. Run queued. The report will appear in the runs list.",
  "{name} is not sent: {reason}": "{name} is not sent: {reason}",
  "{name} updated successfully": "{name} updated successfully",
  "{n} requirement(s) and {m} control(s) will change scope.": "{n} requirement(s) and {m} control(s) will change scope.",
  "{n}d ago": "{n}d ago",
  "{percentage} used": "{percentage} used",
  "{percentage}% of limit": "{percentage}% of limit",
  "{percent}% annual chance of occurrence": "{percent}% annual chance of occurrence",
  "{quantified} of {total} Threat Vectors quantified": "{quantified} of {total} Threat Vectors quantified",
  "{quantified} of {total} threats quantified": "{quantified} of {total} threats quantified",
  "{quantified} of {total} threats quantified.": "{quantified} of {total} threats quantified.",
  "{quantified} of {total} threats quantified: {open}.": "{quantified} of {total} threats quantified: {open}.",
  "{quota}: {used}": "{quota}: {used}",
  "{quota}: {used} of {limit}": "{quota}: {used} of {limit}",
  "{ready} is ready to sign off: every control executed, waiting for someone to mark it fulfilled. | {ready} are ready to sign off: every control executed, waiting for someone to mark them fulfilled.": "{ready} is ready to sign off: every control executed, waiting for someone to mark it fulfilled. | {ready} are ready to sign off: every control executed, waiting for someone to mark them fulfilled.",
  "{started} started, {count} file still processing | {started} started, {count} files still processing": "{started} started, {count} file still processing | {started} started, {count} files still processing",
  "{system} has no threats in its risk register.": "{system} has no threats in its risk register.",
  "{tab} controls list is empty": "{tab} controls list is empty",
  "{tokens} tokens · {requests} prompts": "{tokens} tokens · {requests} prompts",
  "{tokens} tokens · {requests} prompts · {users} active users": "{tokens} tokens · {requests} prompts · {users} active users",
  "{total} of risk on {system}.": "{total} of risk on {system}.",
  "{total} total · {failed} failed": "{total} total · {failed} failed",
  "{value}% vs previous period": "{value}% vs previous period",
  "{when}, older than 90 days": "{when}, older than 90 days",
  "£ - British Pound (GBP)": "£ - British Pound (GBP)",
  "د.إ - United Arab Emirates Dirham (AED)": "د.إ - United Arab Emirates Dirham (AED)",
  "“{title}” deleted.": "“{title}” deleted.",
  "“{title}” is removed from your history.": "“{title}” is removed from your history.",
  "₩ - South Korean Won (KRW)": "₩ - South Korean Won (KRW)",
  "€ - Euro (EUR)": "€ - Euro (EUR)",
  "≠ Not equal to": "≠ Not equal to",
  "≥ {amount}": "≥ {amount}",
  "≥ {min} tokens": "≥ {min} tokens",
  "﷼ - Saudi Riyal (SAR)": "﷼ - Saudi Riyal (SAR)"
}
